export const translations = {

  // ── O'zbek lotin ──────────────────────────────────────────
  uz: {
    appName: "NasiyaSale",
    network: "Arbitrum One",
    // ── Vault ──────────────────────────────────────────────────
    vaultTitle: "Vault",
    vaultOwnerPanel: "Owner paneli faol",
    vaultRefresh: "Yangilash",
    vaultActiveLocks: "Faol locklar",
    vaultNFTLocks: "NFT locklar",
    vaultFaolNFTLocks: "Faol NFT locklar",
    vaultFaolNFTLockYoq: "Faol NFT lock yo'q",
    vaultBalances: "Vault balanslari",
    vaultActiveLocksList: "Faol token locklar",
    vaultNFTLocksList: "NFT (LP) locklar",
    vaultLPValue: "LP qiymati",
    vaultUnlockDate: "Unlock sanasi",
    vaultDeposited: "Kiritilgan",
    vaultStatus: "Holat",
    vaultActive: "Faol",
    vaultUnlocked: "Ochilgan",
    vaultWithdrawn: "Yechildi",
    vaultEmergency: "Favqulodda",
    vaultRebalanced: "Rebalanced",
    vaultEmergencyReady: "Favqulodda tayyor",
    vaultEmergencyIn: "Favqulodda:",
    vaultWithdraw: "Yechish",
    vaultEmergencyBtn: "Emergency",
    vaultRebalanceBtn: "Rebalance",
    vaultNoLocks: "Lock topilmadi",
    vaultNoNFT: "NFT lock topilmadi",
    vaultNoHistory: "Hali tarix yo'q",
    vaultTokenHistory: "Token lock tarixi",
    vaultNFTHistory: "NFT lock tarixi",
    vaultStatistics: "Statistika",
    vaultTotalLocks: "Jami locklar",
    vaultTotalNFT: "Jami NFT",
    vaultWithdrawalAddress: "Withdrawal manzil",
    vaultPrices: "Narxlar va boshqaruv",
    vaultCurrentPrices: "Joriy narxlar",
    vaultUpdatePrices: "Narxlarni yangilash",
    vaultSyncBalance: "Balans sinxronlash",
    vaultSync: "Sinxronlash",
    vaultNFTRebalance: "NFT Rebalance",
    vaultOldNFTLockId: "Eski NFT lock ID",
    vaultNewNFTTokenId: "Yangi NFT Token ID",
    vaultOldNFTHint: "NFT tab dagi lock #raqami",
    vaultNewNFTHint: "Yangi yaratilgan LP pozitsiya ID si",
    vaultRebalance: "Rebalance",
    vaultDepositToken: "Token lock qilish",
    vaultDepositNFT: "NFT lock qilish",
    vaultNFTId: "NFT Token ID",
    vaultNFTDays: "Lock muddati (kun)",
    vaultNFTDaysHint: "Kamida 1 kun",
    vaultLockDate: "Ochilish sanasi",
    vaultLockBtn: "Lock qilish",
    vaultApproveBtn: "Ruxsat berish (Approve)",
    vaultNFTLockBtn: "NFT Lock qilish",
    vaultSelectToken: "Token tanlang",
    vaultAmount: "Miqdor",
    vaultDays: "Muddat (kun)",
    vaultBalance: "Balans",
    vaultSearch: "Qidirish...",
    vaultTabStatistika: "Statistika",
    vaultTabLocklar: "Locklar",
    vaultTabNFT: "NFT",
    vaultTabTarix: "Tarix",
    vaultTabKiritish: "Kiritish",
    vaultTabBoshqaruv: "Boshqaruv",
    vaultWalletNotConnected: "Hamyon ulanmagan",
    vaultEnterAmount: "Miqdor kiriting",
    vaultEnterDays: "Kun soni kiriting",
    vaultInsufficientBalance: "Balans yetarli emas",
    vaultApproving: "Approve...",
    vaultApproveSuccess: "Approve muvaffaqiyatli!",
    vaultLocking: "Lock qilinmoqda...",
    vaultLockSuccess: "kunga lock qilindi!",
    vaultLoadError: "Vault yuklanishda xato",
    vaultWithdrawing: "Yechilmoqda...",
    vaultSuccess: "Muvaffaqiyatli!",
    vaultNFTWithdrawing: "NFT yechilmoqda...",
    vaultNFTWithdrawn: "NFT yechildi!",
    vaultNFTApproving: "NFT approve qilinmoqda...",
    vaultNFTLocking: "NFT lock qilinmoqda...",
    vaultNFTLocked: "kunga lock qilindi!",
    vaultRebalancing: "Rebalance...",
    vaultRebalanceSuccess: "Rebalance amalga oshdi!",
    vaultBLTUpdating: "BLT narxi...",
    vaultDURUpdating: "DUR narxi...",
    vaultPricesUpdated: "Narxlar yangilandi!",
    vaultSyncing: "Sinxronlanmoqda...",
    vaultSyncSuccess: "Balans sinxronlandi!",
    vaultRebalanceSelected: "tanlandi. Yangi NFT Token ID kiriting.",
    vaultUnknownError: "Noma'lum xato",
    vaultReady: "Tayyor",
    vaultCount: " ta",
    // Nav
    navDashboard: "Bosh sahifa",
    navAbout: "Haqida",
    navCreate: "E'lon joylash",
    navListings: "E'lonlar",
    navApproved: "Tasdiqlangan",
    navBL: "BL Darajasi",
    navHistory: "Tarix",
    // Hamyon
    connect: "Hamyon ulash",
    disconnect: "Chiqish",
    wrongNetwork: "Noto'g'ri tarmoq",
    switchNetwork: "Arbitrum ga o'tish",
    walletMetaMask: "MetaMask",
    walletMetaMaskDesc: "Brauzer kengaytmasi orqali",
    walletTrust: "Trust Wallet / Boshqa hamyon",
    walletTrustDesc: "WalletConnect — 300+ hamyon",
    walletView: "Manzil bilan ko'rish",
    walletViewDesc: "Faqat ko'rish rejimi",
    walletViewWarning: "Bu rejimda faqat ko'rish mumkin. Tranzaksiya uchun MetaMask kerak.",
    walletAddress: "Hamyon manzili (0x...)",
    walletViewBtn: "Ko'rish rejimida kirish",
    walletReadOnly: "👁 Ko'rish rejimi",
    walletChecking: "Tekshirilmoqda...",
    walletConnected: "Hamyon ulandi! ✓",
    walletDisconnected: "Hamyon uzildi",
    walletRejected: "Rad etildi",
    walletWCStep1: "Telefonizda Trust Wallet yoki boshqa hamyon ilovasini oching",
    walletWCStep2: "Ilovada 'WalletConnect' tugmasini bosing",
    walletWCStep3: "Sayt manzilini kiriting yoki QR kodni skaner qiling",
    walletWCStep4: "Ulanishni tasdiqlang",
    walletWCNote: "WalletConnect keyingi versiyada qo'shiladi.",
    walletTitle: "Hamyon ulash",
    walletSubtitle: "Ulanish usulini tanlang",
    walletMobileTitle: "Mobil hamyon bilan ulash",
    // Dashboard
    dashTitle: "Bosh sahifa",
    dashSubtitle: "Platforma holati va depozitlaringiz",
    dashWelcome: "NasiyaSale ga xush kelibsiz",
    dashWelcomeDesc: "DUR tokenini nasiya asosida sotish va sotib olish platformasi. Boshlash uchun hamyoningizni ulang.",
    dashDeposits: "Kontrakt depozitlari",
    dashWalletBal: "Hamyon",
    dashStats: "Platforma statistikasi",
    dashSellerL: "Sotuvchi e'lonlari",
    dashBuyerR: "Xaridor so'rovlari",
    dashApprovedS: "Tasdiqlangan",
    dashPending: "Kutilayotgan e'lonlar",
    dashPendingR: "Kutilayotgan so'rovlar",
    dashActive: "Faol shartnomalar",
    dashActions: "Tezkor amallar",
    dashDepositT: "E'lon joylash",
    dashDepositD: "Yangi nasiya savdo e'lonini joylashtiring",
    dashCreateT: "E'lon joylash",
    dashCreateD: "Yangi nasiya savdo e'lonini joylashtiring",
    dashListingsT: "E'lonlar ro'yxati",
    dashListingsD: "Barcha kutilayotgan e'lonlarni ko'ring va tasdiqlang",
    dashApprovedT: "Tasdiqlangan shartnomalar",
    dashApprovedD: "To'lov qiling yoki garovni qaytarib oling",
    // Deposit
    depositTitle: "Depozit",
    depositSubtitle: "Kontraktga token kiriting",
    depositBtn: "Depozit",
    depositWallet: "Hamyon balansi",
    depositContract: "Kontrakt depoziti",
    depositNote: "Birinchi depozitda token ruxsatini (approve) tasdiqlashingiz kerak — bu bir martalik amal.",
    depositDURDesc: "Nasiya savdoda ishlatiladigan asosiy token",
    depositUSDCDesc: "To'lov uchun ishlatiladigan barqaror token",
    depositBLTDesc: "Garov sifatida ishlatiladigan token",
    // E'lon
    createTitle: "E'lon joylash",
    createSubtitle: "DUR nasiya savdosi uchun e'lon joylashtiring",
    createSelectType: "E'lon turini tanlang",
    createAbout: "Bu tur haqida",
    createDUR: "DUR miqdori",
    createPrice: "To'lov summasi (USDC) — qaytariladigan summa",
    createPeriod: "To'lov muddati (kun)",
    createPeriodNote: "Tasdiqlangan kundan boshlab",
    createPeriodNote2: "kun ichida to'lash kerak",
    createBtn: "E'lonni joylashtirish",
    createPosting: "Joylashtirilmoqda...",
    createDURDeposit: "DUR depozitingiz:",
    createBLTDeposit: "BLT depozitingiz:",
    createRequiredBL: "Kerakli BL:",
    createBLTCollateral: "BLT garov miqdori:",
    createSuccess: "E'lon muvaffaqiyatli joylashtirildi!",
    createRejected: "Rad etildi",
    createNoDUR: "DUR depozit yetarli emas!",
    createNoBLT: "BLT depozit yetarli emas!",
    createFillAll: "Barcha maydonlarni to'ldiring!",
    createSelectErr: "Tur tanlang!",
    // Listing turlari
    lt1Title: "Sotuvchi — Garovli",
    lt1Desc: "Siz DUR sotasiz, xaridor garov qo'yadi",
    lt2Title: "Xaridor — Garovli",
    lt2Desc: "Siz DUR sotib olasiz, garov qo'yasiz",
    lt3Title: "Sotuvchi — Garovsiz",
    lt3Desc: "Siz DUR sotasiz, xaridor BL darajasi kerak",
    lt4Title: "Xaridor — Garovsiz",
    lt4Desc: "Siz DUR sotib olasiz, BL darajangiz kerak",
    // Info qatorlar
    infoYouPut: "Siz nima qo'yasiz?",
    infoBuyerPut: "Xaridor nima qo'yadi?",
    infoSellerPut: "Sotuvchi nima qo'yadi?",
    infoIfPaid: "Siz to'lasangiz?",
    infoBuyerPaid: "Xaridor to'lasa?",
    infoIfNotPaid: "Siz to'lamasangiz?",
    infoBuyerNotPaid: "Xaridor to'lamasa?",
    infoNeedBL: "BL kerakmi?",
    infoRisk: "Xavf darajasi?",
    infoRequiredBL: "Kerakli BL miqdori?",
    infoWhereBL: "BL qayerdan keladi?",
    // E'lonlar
    listingsTitle: "E'lonlar",
    listingsSubtitle: "Kutilayotgan nasiya savdo e'lonlari",
    listingsSellerTab: "Sotuvchi e'lonlari",
    listingsBuyerTab: "Xaridor so'rovlari",
    listingsEmpty: "Hozircha e'lonlar yo'q",
    listingsApprove: "Tasdiqlash",
    listingsApproving: "Tasdiqlanmoqda...",
    listingsApproved: "E'lon tasdiqlandi!",
    listingsColID: "ID",
    listingsColType: "Tur",
    listingsColAmount: "DUR / USDC",
    listingsColSeller: "Sotuvchi",
    listingsColBuyer: "Xaridor",
    listingsColPeriod: "Muddat",
    listingsColStatus: "Holat",
    listingsColAction: "Amal",
    listingsCollateral: "Garovli",
    listingsNoCollateral: "Garovsiz",
    listingsYours: "Sizning",
    listingsNoDURDep: "DUR depozit yetarli emas",
    listingsNoBLTDep: "BLT depozit yetarli emas",
    listingsLowBL: "Xaridorning BL darajasi yetarli emas",
    // Tasdiqlangan
    approvedTitle: "Tasdiqlangan shartnomalar",
    approvedSubtitle: "Faol nasiya savdo shartnomalari",
    approvedEmpty: "Faol shartnomalar yo'q",
    approvedUSDCWarn: "USDC depozitingiz:",
    approvedUSDCWarn2: "To'lov qilish uchun avval USDC depozit qiling.",
    approvedPay: "To'lov qilish",
    approvedClaimCol: "Default claim qilish",
    approvedClaimBL: "Default claim qilish",
    approvedYouBuyer: "Siz xaridor",
    approvedYouSeller: "Siz sotuvchi",
    approvedExpired: "Muddati o'tgan",
    approvedTimeLeft: "qoldi",
    approvedDays: "kun",
    approvedHours: "soat",
    approvedPaySuccess: "To'lov muvaffaqiyatli amalga oshirildi!",
    approvedClaimColSuccess: "Default claim muvaffaqiyatli bajarildi!",
    approvedClaimBLSuccess: "Default claim muvaffaqiyatli bajarildi!",
    approvedNoUSDC: "USDC depozit yetarli emas",
    approvedDeadline: "Muddat o'tib ketgan",
    approvedClaimDefault: "Default claim qilish",
    approvedClaimDefaultSuccess: "Default claim muvaffaqiyatli bajarildi!",
    statusDefaulted: "Default / to‘lanmagan",
    payAfterDefault: "Keyin to‘lash",
    payAfterDefaultSuccess: "Default qarz to‘landi!",
    blacklistedWarning: "Siz qora ro‘yxatdasiz. Garovsiz sotib ololmaysiz.",
    unpaidDefaultLeft: "To‘lanmagan defaultlar",
    // BL
    blTitle: "BL Darajasi",
    blSubtitle: "Xaridor-sotuvchi ishonch darajasini tekshiring",
    blBuyer: "Xaridor manzili",
    blSeller: "Sotuvchi manzili",
    blMe: "Men",
    blCheck: "BL tekshirish",
    blChecking: "Tekshirilmoqda...",
    blTotal: "Jami BL darajasi",
    blTotalDesc: "Xaridor tomonidan to'plangan umumiy ishonch",
    blBusy: "Band BL",
    blBusyDesc: "Kutilayotgan so'rovlar uchun band",
    blFree: "Erkin BL",
    blFreeDesc: "Yangi savdolar uchun mavjud",
    blNote: "Garovsiz savdoda xaridor DUR miqdori × 10 ga teng BL darajasiga ega bo'lishi kerak.",
    blFillBoth: "Ikkala manzilni kiriting!",
    blInvalidAddr: "Noto'g'ri manzil formati!",
    blMyAddr: "Mening manzilim",
    blResultLevel: "BL darajasi",
    blResultBusy: "Band qilingan BL",
    blResultFree: "Erkin BL",
    blExplanation: "BL darajasi garovli savdolardan to'lov qilganda oshadi (DUR÷10), garovsizda DUR miqdoricha oshadi. To'lov qilinmasa BL 0 ga tushadi.",
    blBuyerAddress: "Xaridor manzili",
    blSellerAddress: "Sotuvchi manzili (ixtiyoriy)",
    blSearching: "Qidirilmoqda...",
    blSearch: "Qidirish",
    blTotalLevel: "Umumiy BL darajasi",
    blTotalBL: "Total BL",
    blPendingBL: "Band qilingan BL",
    blFreeTotal: "Erkin umumiy BL",
    blPairwise: "Shu sotuvchi bilan pairwise BL",
    blActiveExposure: "Faol garovsiz qarz (shu sotuvchi)",
    blBlacklist: "Qora ro'yxat",
    blYes: "Ha",
    blNo: "Yo'q",
    blUnpaidNoCollateral: "Garovsiz to'lanmagan qarzlar",
    blUnpaidDefault: "Jami to'lanmagan qarzlar",
    blInfo: "Garovsiz e'lonni tasdiqlashda kontrakt ko'pincha umumiy BL emas, sotuvchi bilan pairwise BL yoki erkin umumiy BL shartini tekshiradi.",
    // Tarix
    historyTitle: "Tranzaksiya tarixi",
    historySubtitle: "Sizning so'nggi amallari",
    historyClear: "Tozalash",
    historyEmpty: "Hali tranzaksiyalar yo'q",
    historyEmptyDesc: "Amallar bajarganingizda bu yerda ko'rinadi",
    historyExplorer: "Explorer",
    historyListing: "E'lon",
    historyRole: "Rol",
    historyNewBL: "Yangi BL:",
    historyBLT: "BLT:",
    historyCreated: "E'lon joylashtirildi",
    historyApproved: "E'lon tasdiqlandi",
    historyPaid: "To'lov amalga oshirildi",
    historyCollateral: "Garov qaytarildi",
    historyBLClaimed: "Default claim qilindi",
    historyBuyer: "xaridor",
    historySeller: "sotuvchi",
    historySecondsAgo: "soniya oldin",
    historyMinutesAgo: "daqiqa oldin",
    historyHoursAgo: "soat oldin",
    historyDaysAgo: "kun oldin",
    // Status
    statusPendingSellerC: "Sotuvchi kutmoqda (garovli)",
    statusPendingBuyerC: "Xaridor kutmoqda (garovli)",
    statusPendingSellerN: "Sotuvchi kutmoqda (garovsiz)",
    statusPendingBuyerN: "Xaridor kutmoqda (garovsiz)",
    statusApproved: "Tasdiqlangan",
    statusRemoved: "Bekor qilingan",
    statusPaid: "To'langan",
    statusClaimCol: "Default",
    statusClaimBL: "Default",
    // Umumiy
    // Tokenomics
    tokenSubtitle: "DUR va BLT tokenlar haqida to'liq ma'lumot — taklif, lock va bozor qiymati",
    tokenTotalSupply: "Jami taklif",
    tokenCirculating: "Erkin muomala",
    tokenLocked: "Lock qilingan",
    tokenPrice: "Narx",
    tokenDistribution: "Umumiy taqsimot",
    tokenAbout: "Loyiha haqida",
    tokenAddresses: "Token manzillari",
    connectPrompt: "Tranzaksiya uchun hamyonni ulang",
    aboutDoc: "Hujjat",
    noData: "Ma'lumot yo'q",
    errorOccurred: "Xato yuz berdi",
    days: "kun",
    // About sahifasi
    aboutPageTitle: "Platforma haqida",
    aboutPageSubtitle: "NasiyaSale — markazlashmagan nasiya savdo platformasi",
    aboutWhatIs: "NasiyaSale nima?",
    aboutWhatIsDesc1: "NasiyaSale — bu DUR tokenini nasiya asosida sotish va sotib olish uchun ishlab chiqilgan markazlashmagan platforma. Barcha savdolar smart kontrakt orqali amalga oshiriladi va hech qanday vositachi yoki boshqaruvchi talab etilmaydi.",
    aboutWhatIsDesc2: "Sotuvchi DUR tokenini joylashtiradi, xaridor uni nasiyaga oladi va belgilangan muddat ichida USDC bilan to'laydi. Garovli savdolarda xaridor garov qo'yadi — agar to'lamasa, garov sotuvchiga o'tadi.",
    aboutSmartTitle: "Smart kontrakt — inson boshqarmaydi",
    aboutSmartDesc1: "Barcha amallar (e'lon joylash, tasdiqlash, to'lov, garov qaytarish) to'liq smart kontrakt tomonidan bajariladi. Hech qanday admin, owner yoki boshqaruvchi yo'q — kontrakt avtonomdir.",
    aboutSmartDesc2: "Hech kim kontraktni to'xtata olmaydi, tokenlarni o'g'irlay olmaydi yoki qoidalarni o'zgartira olmaydi. Kod bir marta deploy qilingan va o'zgartirilmaydi.",
    aboutHowTitle: "Qanday ishlaydi?",
    aboutStep1Title: "1. E'lon joylash",
    aboutStep1Desc: "Sotuvchi yoki xaridor e'lon joylashtiradi. Sotuvchi DUR tokenini hamyonidan kontraktga beradi.",
    aboutStep2Title: "2. Tasdiqlash",
    aboutStep2Desc: "Ikkinchi tomon e'lonni ko'rib, tasdiqlaydi. Garovli savdolarda garov tokeni hamyondan olinadi. DUR xaridorga beriladi.",
    aboutStep3Title: "3. To'lov",
    aboutStep3Desc: "Xaridor belgilangan muddatda USDC bilan to'laydi. To'lov hamyondan to'g'ridan-to'g'ri sotuvchiga o'tadi. Garov qaytariladi.",
    aboutStep4Title: "4. To'lanmasa",
    aboutStep4Desc: "Muddat o'tgandan keyin sotuvchi garovni oladi (garovli) yoki xaridorning BL darajasi 0 ga tushadi (garovsiz).",
    aboutBLTitle: "BL (Business Level) tizimi",
    aboutBLDesc: "BL — xaridor va sotuvchi o'rtasidagi ishonch darajasi. Har bir muvaffaqiyatli to'lov BL ni oshiradi:",
    aboutBLRow1Label: "Garovli savdo",
    aboutBLRow1Value: "BL += DUR miqdori ÷ 10",
    aboutBLRow2Label: "Garovsiz savdo",
    aboutBLRow2Value: "BL += DUR miqdori",
    aboutBLRow3Label: "To'lov qilinmasa",
    aboutBLRow3Value: "Faqat o‘sha sotuvchi bilan BL = 0 bo‘ladi",
    aboutBLRow4Label: "Garovsiz e'lon uchun",
    aboutBLRow4Value: "BL ≥ DUR × 10 kerak",
    aboutTokensTitle: "Qo'llab-quvvatlanadigan tokenlar",
    aboutTokenDUR: "Nasiya savdoda sotiladigan asosiy token",
    aboutTokenUSDC: "To'lov va garov uchun barqaror token",
    aboutTokenUSDT: "Garov sifatida ishlatilishi mumkin",
    aboutTokenBLT: "Garov tokeni, narxi Uniswap V4 dan o'qiladi",
    aboutTokenWBTC: "Bitcoin o'rami, garov sifatida",
    aboutTokenWETH: "Ethereum o'rami, garov sifatida",
    aboutRoleTrade: "Savdo",
    aboutRolePayCol: "To'lov / Garov",
    aboutRoleCol: "Garov",
    // Tarix sahifasi
    txTitle: "Tranzaksiya tarixi",
    txSubtitle: "Sizning tranzaksiyalaringiz tarixi",
    txRefresh: "Yangilash",
    txLoading: "Yuklanmoqda...",
    txEmpty: "Hali tranzaksiyalar yo'q",
    txEventCreated: "E'lon joylashtirildi",
    txEventApproved: "E'lon tasdiqlandi",
    txEventCancelled: "E'lon bekor qilindi",
    txEventPaid: "To'lov amalga oshdi",
    txEventCollateral: "Garov qaytarildi",
    txEventBLClaimed: "Default claim qilindi",
    txLabelCreateListing: "E'lon joylash",
    txLabelListingApprove: "E'lon tasdiqlash",
    txLabelListingCancel: "E'lon bekor qilish",
    txLabelPayment: "To'lov amalga oshirildi",
    txLabelDefaultClaim: "Default talab qilindi",
    txLabelPayAfterDefault: "Qarz to'landi (default keyin)",

    navSettings: "Sozlamalar",
    settingsTitle: "Sozlamalar",
    settingsSubtitle: "E'lon berish sozlamalari. Bir marta belgilang \u2014 har e'lon uchun avtomatik ishlatiladi.",
    settingsDurationLabel: "E'lon muddati",
    settingsDurationDesc: "Yangi e'lon shu muddat ichida tasdiqlanmasa, avtomatik bekor bo'ladi. Default: 90 kun.",
    settingsDurationRange: "Oraliq",
    settingsDays: "kun",
    settingsSaved: "Saqlandi",
    settingsDeviationLabel: "Narx farqi cheklovi",
    settingsDeviationDesc: "E'lonni tasdiqlash vaqtida bozor narxi lock narxidan shuncha foizdan ko'p farqlansa, tranzaksiya avtomatik bekor qilinadi (flash loan himoyasi). Default: 0.01%.",    // CreateListing — info paneli

    settingsApproveMultLabel: "Approve miqdori",
    settingsApproveMultDesc: "Har e'lon uchun qancha token approve qilinsin. Yuqori qiymat = kelgusi e'lonlarda approve qayta so'ralmaydi (gaz tejaydi), lekin kontraktga ko'proq ishonish kerak.",
    settingsApproveMult1: "1x (kerakli)",
    settingsApproveMultMax: "Cheksiz",
    settingsApproveMultMaxWarn: "Cheksiz approve \u2014 kontrakt istalgan vaqtda shu tokendan cheksiz miqdor yecha oladi. Faqat ishonchli kontraktlar uchun.",
    settingsRevokeLabel: "Barcha approve'larni bekor qilish",
    settingsRevokeDesc: "Kontraktga berilgan barcha token ruxsatlarini 0 ga tushiradi. Faqat ruxsat berilgan tokenlar uchun tranzaksiya yuboriladi (har biri uchun alohida tasdiq). Xavfsizlik uchun savdoni tugatgandan keyin foydalaning.",
    settingsRevokeBtn: "Barchasini bekor qilish",
    settingsRevoking: "Bekor qilinmoqda...",
    settingsRevokeChecking: "Approve'lar tekshirilmoqda...",
    settingsRevokeProgress: "bekor qilinmoqda...",
    settingsRevokeNone: "Bekor qilinadigan approve yo'q",
    settingsRevokeDone: "approve bekor qilindi",
    settingsRevokeRejected: "Bekor qilish rad etildi",
    settingsRevokeConfirmQ: "Ishonchingiz komilmi? Har bir token uchun alohida tasdiq so'raladi.",
    settingsRevokeConfirmYes: "Ha, bekor qil",
    settingsRevokeConfirmNo: "Yo'q",    clInfoDURFromWallet: "DUR token (hamyondan)",
    clInfoCollateralOnApproval: "Tanlangan tokenlardan garov (tasdiqlashda olinadi)",
    clInfoBuyerPaidCollateral: "USDC olasiz, xaridorning BL darajasi oshadi (DUR÷10)",
    clInfoBuyerNotPaidCollateral: "Garovni olasiz, xaridorning BL = 0",
    clInfoNoNeedBL: "Yo'q",
    clInfoCollateralTakenOnPost: "✅ Garov tokeni E'LON PAYTIDA hamyondan olinadi",
    clInfoSellerDUROnApproval: "DUR token (tasdiqlashda olinadi)",
    clInfoYouPaidCollateral: "Garov qaytadi, sizning BL darajangiz oshadi (DUR÷10)",
    clInfoYouNotPaidCollateral: "Garov sotuvchiga, sizning BL = 0",
    clInfoOnlyBLNeeded: "Hech narsa — faqat BL kerak",
    clInfoBuyerPaidNoColl: "USDC olasiz, xaridorning BL darajasi oshadi (DUR miqdori)",
    clInfoBuyerNotPaidNoColl: "Hech narsa yo'q — xaridorning BL = 0",
    clInfoRiskHigh: "⚠️ Yuqori",
    clInfoBLFromPrevious: "Avvalgi garovli savdolardan",
    clInfoYouPaidNoColl: "Sizning BL darajangiz oshadi (DUR miqdoricha)",
    clInfoYouNotPaidNoColl: "Sizning BL = 0 bo'ladi",
    clDURFromWalletAlert: "DUR hamyoningizdan olinadi. Hamyonda:",
    clCollateralBuyWarningTitle: "Diqqat!",
    clCollateralBuyWarning: "E'lon joylashtirilganda garov tokeni darhol hamyoningizdan contractga o'tkaziladi. Sotuvchi tasdiqlashidan oldin e'lonni bekor qilsangiz garov qaytariladi.",
    clSelectCollateralTokens: "Xaridor qaysi tokenlardan garov bera oladi?",
    clCurrentPricePreview: "Hozirgi narx bo'yicha xaridor qo'yishi kerak bo'lgan garov miqdori:",
    clPriceLockWarning: "⚠ E'lon berilgach bu narxlar lock qilinadi — tasdiqlash vaqtida bozor narxi o'zgarsa ham shu miqdor olinadi",
    clSelectCollateralToken: "Garov tokeni tanlang",
    clTokenTakenOnPost: "(e'lon paytida hamyondan olinadi)",
    clRequiredCollateral: "Kerakli garov miqdori:",
    clWalletBalance: "Hamyonda:",
    clInsufficientToken: "— yetarli emas!",
    clEnterDUR: "DUR miqdorini kiriting!",
    clEnterPrice: "Narxni kiriting!",
    clEnterPeriod: "To'lov muddatini kiriting!",
    clSelectOneToken: "Kamida bitta garov tokeni tanlang!",
    clDURInsufficient: "DUR yetarli emas! Hamyonda:",
    clTokenInsufficient: "yetarli emas! Hamyonda:",
    clTokenNeeded: "kerak:",
    clWalletInsufficient: "Hamyonda yetarli token yo'q!",
    clZeroCollateral: "Garov miqdori nol — narxni tekshiring!",
    clPaymentProcessing: "To'lov amalga oshirilmoqda...",
    // Approved sahifasi
    approvedUSDCAlert: "To'lov uchun USDC hamyoningizdan olinadi. Hamyonda:",
    approvedRefresh: "Yangilash",
    approvedCollateralLabel: "Garov:",
    approvedUSDCInsufficient: "USDC yetarli emas!",
    // Dashboard — faol foydalanuvchilar
    dashActiveUsers: "Faol ishtirokchilar",
    dashActiveUsersDesc: "Noyob manzillar",
    // Qidiruv va filtr
    searchPlaceholder: "ID, manzil yoki miqdor...",
    filterAll: "Barchasi",
  },

  // ── O'zbek Kiril ──────────────────────────────────────────
  kr: {
    appName: "NasiyaSale",
    network: "Arbitrum One",
    // ── Vault ──────────────────────────────────────────────────
    vaultTitle: "Vault",
    vaultOwnerPanel: "Owner панели фаол",
    vaultRefresh: "Янгилаш",
    vaultActiveLocks: "Фаол локлар",
    vaultNFTLocks: "NFT локлар",
    vaultFaolNFTLocks: "Фаол NFT локлар",
    vaultFaolNFTLockYoq: "Фаол NFT лок йўқ",
    vaultBalances: "Vault баланслари",
    vaultActiveLocksList: "Фаол токен локлар",
    vaultNFTLocksList: "NFT (LP) локлар",
    vaultLPValue: "LP қиймати",
    vaultUnlockDate: "Unlock санаси",
    vaultDeposited: "Киритилган",
    vaultStatus: "Ҳолат",
    vaultActive: "Фаол",
    vaultUnlocked: "Очилган",
    vaultWithdrawn: "Ечилди",
    vaultEmergency: "Фавқулодда",
    vaultRebalanced: "Rebalanced",
    vaultEmergencyReady: "Фавқулодда тайёр",
    vaultEmergencyIn: "Фавқулодда:",
    vaultWithdraw: "Ечиш",
    vaultEmergencyBtn: "Emergency",
    vaultRebalanceBtn: "Rebalance",
    vaultNoLocks: "Лок топилмади",
    vaultNoNFT: "NFT лок топилмади",
    vaultNoHistory: "Ҳали тарих йўқ",
    vaultTokenHistory: "Токен лок тарихи",
    vaultNFTHistory: "NFT лок тарихи",
    vaultStatistics: "Статистика",
    vaultTotalLocks: "Жами локлар",
    vaultTotalNFT: "Жами NFT",
    vaultWithdrawalAddress: "Withdrawal манзил",
    vaultPrices: "Нархлар ва бошқарув",
    vaultCurrentPrices: "Жорий нархлар",
    vaultUpdatePrices: "Нархларни янгилаш",
    vaultSyncBalance: "Баланс синхронлаш",
    vaultSync: "Синхронлаш",
    vaultNFTRebalance: "NFT Rebalance",
    vaultOldNFTLockId: "Эски NFT лок ID",
    vaultNewNFTTokenId: "Янги NFT Token ID",
    vaultOldNFTHint: "NFT таб даги лок #рақами",
    vaultNewNFTHint: "Янги яратилган LP позиция ID си",
    vaultRebalance: "Rebalance",
    vaultDepositToken: "Токен лок қилиш",
    vaultDepositNFT: "NFT лок қилиш",
    vaultNFTId: "NFT Token ID",
    vaultNFTDays: "Лок муддати (кун)",
    vaultNFTDaysHint: "Камида 1 кун",
    vaultLockDate: "Очилиш санаси",
    vaultLockBtn: "Лок қилиш",
    vaultApproveBtn: "Рухсат бериш (Approve)",
    vaultNFTLockBtn: "NFT Лок қилиш",
    vaultSelectToken: "Токен танланг",
    vaultAmount: "Миқдор",
    vaultDays: "Муддат (кун)",
    vaultBalance: "Баланс",
    vaultSearch: "Қидириш...",
    vaultTabStatistika: "Статистика",
    vaultTabLocklar: "Локлар",
    vaultTabNFT: "NFT",
    vaultTabTarix: "Тарих",
    vaultTabKiritish: "Киритиш",
    vaultTabBoshqaruv: "Бошқарув",
    vaultWalletNotConnected: "Ҳамён уланмаган",
    vaultEnterAmount: "Миқдор киритинг",
    vaultEnterDays: "Кун сони киритинг",
    vaultInsufficientBalance: "Баланс етарли эмас",
    vaultApproving: "Approve...",
    vaultApproveSuccess: "Approve муваффақиятли!",
    vaultLocking: "Лок қилинмоқда...",
    vaultLockSuccess: "кунга лок қилинди!",
    vaultLoadError: "Vault юкланишда хато",
    vaultWithdrawing: "Ечилмоқда...",
    vaultSuccess: "Муваффақиятли!",
    vaultNFTWithdrawing: "NFT ечилмоқда...",
    vaultNFTWithdrawn: "NFT ечилди!",
    vaultNFTApproving: "NFT approve қилинмоқда...",
    vaultNFTLocking: "NFT лок қилинмоқда...",
    vaultNFTLocked: "кунга лок қилинди!",
    vaultRebalancing: "Rebalance...",
    vaultRebalanceSuccess: "Rebalance амалга ошди!",
    vaultBLTUpdating: "BLT нархи...",
    vaultDURUpdating: "DUR нархи...",
    vaultPricesUpdated: "Нархлар янгиланди!",
    vaultSyncing: "Синхронланмоқда...",
    vaultSyncSuccess: "Баланс синхронланди!",
    vaultRebalanceSelected: "танланди. Янги NFT Token ID киритинг.",
    vaultUnknownError: "Номаълум хато",
    vaultReady: "Тайёр",
    navDashboard: "Бош саҳифа",
    navAbout: "Ҳақида",
    navCreate: "Эълон жойлаш",
    navListings: "Эълонлар",
    navApproved: "Тасдиқланган",
    navBL: "БЛ Даражаси",
    navHistory: "Тарих",
    connect: "Ҳамён улаш",
    disconnect: "Чиқиш",
    wrongNetwork: "Нотўғри тармоқ",
    switchNetwork: "Arbitrum га ўтиш",
    walletMetaMask: "MetaMask",
    walletMetaMaskDesc: "Браузер кенгайтмаси орқали",
    walletTrust: "Trust Wallet / Бошқа ҳамён",
    walletTrustDesc: "WalletConnect — 300+ ҳамён",
    walletView: "Манзил билан кўриш",
    walletViewDesc: "Фақат кўриш режими",
    walletViewWarning: "Бу режимда фақат кўриш мумкин. Трансакция учун MetaMask керак.",
    walletAddress: "Ҳамён манзили (0x...)",
    walletViewBtn: "Кўриш режимида кириш",
    walletReadOnly: "👁 Кўриш режими",
    walletChecking: "Текширилмоқда...",
    walletConnected: "Ҳамён уланди! ✓",
    walletDisconnected: "Ҳамён узилди",
    walletRejected: "Рад этилди",
    walletWCStep1: "Телефонизда Trust Wallet ёки бошқа ҳамён иловасини очинг",
    walletWCStep2: "Иловада 'WalletConnect' тугмасини bosing",
    walletWCStep3: "Сайт манзилини киритинг ёки QR кодни сканер қилинг",
    walletWCStep4: "Уланишни тасдиқланг",
    walletWCNote: "WalletConnect кейинги версияда қўшилади.",
    walletTitle: "Ҳамён улаш",
    walletSubtitle: "Уланиш усулини танланг",
    walletMobileTitle: "Мобил ҳамён билан улаш",
    dashTitle: "Бош саҳифа",
    dashSubtitle: "Платформа ҳолати ва депозитларингиз",
    dashWelcome: "NasiyaSaleга хуш келибсиз",
    dashWelcomeDesc: "DUR токенини насия асосида сотиш ва сотиб олиш платформаси. Бошлаш учун ҳамёнингизни уланг.",
    dashDeposits: "Контракт депозитлари",
    dashWalletBal: "Ҳамён",
    dashStats: "Платформа статистикаси",
    dashSellerL: "Сотувчи эълонлари",
    dashBuyerR: "Харидор сўровлари",
    dashApprovedS: "Тасдиқланган",
    dashPending: "Кутилаётган эълонлар",
    dashPendingR: "Кутилаётган сўровлар",
    dashActive: "Фаол шартномалар",
    dashActions: "Тезкор амаллар",
    dashDepositT: "Депозит қўшиш",
    dashDepositD: "DUR, USDC ёки BLT токенларини контрактга киритинг",
    dashCreateT: "Эълон жойлаш",
    dashCreateD: "Янги насия савдо эълонини жойлаштиринг",
    dashListingsT: "Эълонлар рўйхати",
    dashListingsD: "Барча кутилаётган эълонларни кўринг ва тасдиқланг",
    dashApprovedT: "Тасдиқланган шартномалар",
    dashApprovedD: "Тўлов қилинг ёки гаровни қайтариб олинг",
    depositTitle: "Депозит",
    depositSubtitle: "Контрактга токен киритинг",
    depositBtn: "Депозит",
    depositWallet: "Ҳамён баланси",
    depositContract: "Контракт депозити",
    depositNote: "Биринчи депозитда токен рухсатини (approve) тасдиқлашингиз керак — бу бир марталик амал.",
    depositDURDesc: "Насия савдода ишлатиладиган асосий токен",
    depositUSDCDesc: "Тўлов учун ишлатиладиган барқарор токен",
    depositBLTDesc: "Гаров сифатида ишлатиладиган токен",
    createTitle: "Эълон жойлаш",
    createSubtitle: "DUR насия савдоси учун эълон жойлаштиринг",
    createSelectType: "Эълон турини танланг",
    createAbout: "Бу тур ҳақида",
    createDUR: "DUR миқдори",
    createPrice: "Тўлов суммаси (USDC)",
    createPeriod: "Тўлов муддати (кун)",
    createPeriodNote: "Тасдиқланган кундан бошлаб",
    createPeriodNote2: "кун ичида тўлаш керак",
    createBtn: "Эълонни жойлаштириш",
    createPosting: "Жойлаштирилмоқда...",
    createDURDeposit: "DUR депозитингиз:",
    createBLTDeposit: "BLT депозитингиз:",
    createRequiredBL: "Керакли БЛ:",
    createBLTCollateral: "BLT гаров миқдори:",
    createSuccess: "Эълон муваффақиятли жойлаштирилди!",
    createRejected: "Рад этилди",
    createNoDUR: "DUR депозит етарли эмас!",
    createNoBLT: "BLT депозит етарли эмас!",
    createFillAll: "Барча майдонларни тўлдиринг!",
    createSelectErr: "Тур танланг!",
    lt1Title: "Сотувчи — Гаровли",
    lt1Desc: "Сиз DUR сотасиз, харидор гаров қўяди",
    lt2Title: "Харидор — Гаровли",
    lt2Desc: "Сиз DUR сотиб оласиз, гаров қўясиз",
    lt3Title: "Сотувчи — Гаровсиз",
    lt3Desc: "Сиз DUR сотасиз, харидор БЛ даражаси керак",
    lt4Title: "Харидор — Гаровсиз",
    lt4Desc: "Сиз DUR сотиб оласиз, БЛ даражангиз керак",
    infoYouPut: "Сиз нима қўясиз?",
    infoBuyerPut: "Харидор нима қўяди?",
    infoSellerPut: "Сотувчи нима қўяди?",
    infoIfPaid: "Сиз тўласангиз?",
    infoBuyerPaid: "Харидор тўласа?",
    infoIfNotPaid: "Сиз тўламасангиз?",
    infoBuyerNotPaid: "Харидор тўламаса?",
    infoNeedBL: "БЛ керакми?",
    infoRisk: "Хавф даражаси?",
    infoRequiredBL: "Керакли БЛ миқдори?",
    infoWhereBL: "БЛ қаердан келади?",
    listingsTitle: "Эълонлар",
    listingsSubtitle: "Кутилаётган насия савдо эълонлари",
    listingsSellerTab: "Сотувчи эълонлари",
    listingsBuyerTab: "Харидор сўровлари",
    listingsEmpty: "Ҳозирча эълонлар йўқ",
    listingsApprove: "Тасдиқлаш",
    listingsApproving: "Тасдиқланмоқда...",
    listingsApproved: "Эълон тасдиқланди!",
    listingsColID: "ИД",
    listingsColType: "Тур",
    listingsColAmount: "DUR / USDC",
    listingsColSeller: "Сотувчи",
    listingsColBuyer: "Харидор",
    listingsColPeriod: "Муддат",
    listingsColStatus: "Ҳолат",
    listingsColAction: "Амал",
    listingsCollateral: "Гаровли",
    listingsNoCollateral: "Гаровсиз",
    listingsYours: "Сизнинг",
    listingsNoDURDep: "DUR депозит етарли эмас",
    listingsNoBLTDep: "BLT депозит етарли эмас",
    listingsLowBL: "Харидорнинг БЛ даражаси етарли эмас",
    approvedTitle: "Тасдиқланган шартномалар",
    approvedSubtitle: "Фаол насия савдо шартномалари",
    approvedEmpty: "Фаол шартномалар йўқ",
    approvedUSDCWarn: "USDC депозитингиз:",
    approvedUSDCWarn2: "Тўлов қилиш учун аввал USDC депозит қилинг.",
    approvedPay: "Тўлов қилиш",
    approvedClaimCol: "Default claim qilish",
    approvedClaimBL: "Default claim qilish",
    approvedYouBuyer: "Сиз харидор",
    approvedYouSeller: "Сиз сотувчи",
    approvedExpired: "Муддати ўтган",
    approvedTimeLeft: "қолди",
    approvedDays: "кун",
    approvedHours: "соат",
    approvedPaySuccess: "Тўлов муваффақиятли амалга оширилди!",
    approvedClaimColSuccess: "Default claim muvaffaqiyatli bajarildi!",
    approvedClaimBLSuccess: "Default claim muvaffaqiyatli bajarildi!",
    approvedNoUSDC: "USDC депозит етарли эмас",
    approvedDeadline: "Муддат ўтиб кетган",
    approvedClaimDefault: "Default claim qilish",
    approvedClaimDefaultSuccess: "Default claim muvaffaqiyatli bajarildi!",
    statusDefaulted: "Default / to‘lanmagan",
    payAfterDefault: "Keyin to‘lash",
    payAfterDefaultSuccess: "Default qarz to‘landi!",
    blacklistedWarning: "Siz qora ro‘yxatdasiz. Garovsiz sotib ololmaysiz.",
    unpaidDefaultLeft: "To‘lanmagan defaultlar",
    blTitle: "БЛ Даражаси",
    blSubtitle: "Харидор-сотувчи ишонч даражасини текширинг",
    blBuyer: "Харидор манзили",
    blSeller: "Сотувчи манзили",
    blMe: "Мен",
    blCheck: "БЛ текшириш",
    blChecking: "Текширилмоқда...",
    blTotal: "Жами БЛ даражаси",
    blTotalDesc: "Харидор томонидан тўпланган умумий ишонч",
    blBusy: "Банд БЛ",
    blBusyDesc: "Кутилаётган сўровлар учун банд",
    blFree: "Эркин БЛ",
    blFreeDesc: "Янги савдолар учун мавжуд",
    blNote: "Гаровсиз савдода харидор DUR миқдори × 10 га тенг БЛ даражасига эга бўлиши керак.",
    blFillBoth: "Иккала манзилни киритинг!",
    blInvalidAddr: "Нотўғри манзил формати!",
    blMyAddr: "Менинг манзилим",
    blResultLevel: "БЛ даражаси",
    blResultBusy: "Банд қилинган БЛ",
    blResultFree: "Эркин БЛ",
    blExplanation: "БЛ даражаси гаровли савдолардан тўлов қилганда ошади (DUR÷10), гаровсизда DUR миқдорича ошади. Тўлов қилинмаса БЛ 0 га тушади.",
    blBuyerAddress: "Харидор манзили",
    blSellerAddress: "Сотувчи манзили (ихтиёрий)",
    blSearching: "Қидирилмоқда...",
    blSearch: "Қидириш",
    blTotalLevel: "Умумий BL даражаси",
    blTotalBL: "Total BL",
    blPendingBL: "Банд қилинган BL",
    blFreeTotal: "Эркин умумий BL",
    blPairwise: "Шу сотувчи билан pairwise BL",
    blActiveExposure: "Фаол гаровсиз қарз (шу сотувчи)",
    blBlacklist: "Қора рўйхат",
    blYes: "Ҳа",
    blNo: "Йўқ",
    blUnpaidNoCollateral: "Гаровсиз тўланмаган қарзлар",
    blUnpaidDefault: "Жами тўланмаган қарзлар",
    blInfo: "Гаровсиз эълонни тасдиқлашда контракт кўпинча умумий BL эмас, сотувчи билан pairwise BL ёки эркин умумий BL шартини текширади.",
    historyTitle: "Трансакция тарихи",
    historySubtitle: "Сизнинг сўнгги амалларингиз",
    historyClear: "Тозалаш",
    historyEmpty: "Ҳали трансакциялар йўқ",
    historyEmptyDesc: "Амаллар бажарганингизда бу ерда кўринади",
    historyExplorer: "Explorer",
    historyListing: "Эълон",
    historyRole: "Рол",
    historyNewBL: "Янги БЛ:",
    historyBLT: "BLT:",
    historyCreated: "Эълон жойлаштирилди",
    historyApproved: "Эълон тасдиқланди",
    historyPaid: "Тўлов амалга оширилди",
    historyCollateral: "Гаров қайтарилди",
    historyBLClaimed: "Default claim qilindi",
    historyBuyer: "харидор",
    historySeller: "сотувчи",
    historySecondsAgo: "сония олдин",
    historyMinutesAgo: "дақиқа олдин",
    historyHoursAgo: "соат олдин",
    historyDaysAgo: "кун олдин",
    statusPendingSellerC: "Сотувчи кутмоқда (гаровли)",
    statusPendingBuyerC: "Харидор кутмоқда (гаровли)",
    statusPendingSellerN: "Сотувчи кутмоқда (гаровсиз)",
    statusPendingBuyerN: "Харидор кутмоқда (гаровсиз)",
    statusApproved: "Тасдиқланган",
    statusRemoved: "Бекор қилинган",
    statusPaid: "Тўланган",
    statusClaimCol: "Default",
    statusClaimBL: "Default",
    // Tokenomics
    tokenSubtitle: "DUR va BLT токенлар ҳақида тўлиқ маълумот — таклиф, lock ва бозор қиймати",
    tokenTotalSupply: "Жами таклиф",
    tokenCirculating: "Эркин муомала",
    tokenLocked: "Lock қилинган",
    tokenPrice: "Нарх",
    tokenDistribution: "Умумий тақсимот",
    tokenAbout: "Лойиҳа ҳақида",
    tokenAddresses: "Токен манзиллари",
    connectPrompt: "Трансакция учун ҳамённи уланг",
    aboutDoc: "Ҳужжат",
    noData: "Маълумот йўқ",
    errorOccurred: "Хато юз берди",
    days: "кун",
    // Ҳақида саҳифаси
    aboutPageTitle: "Платформа ҳақида",
    aboutPageSubtitle: "NasiyaSale — марказлашмаган насия савдо платформаси",
    aboutWhatIs: "NasiyaSale нима?",
    aboutWhatIsDesc1: "NasiyaSale — бу DUR токенини насия асосида сотиш ва сотиб олиш учун ишлаб чиқилган марказлашмаган платформа. Барча савдолар смарт контракт орқали амалга оширилади ва ҳеч қандай воситачи ёки бошқарувчи талаб этилмайди.",
    aboutWhatIsDesc2: "Сотувчи DUR токенини жойлаштиради, харидор уни насияга олади ва белгиланган муддат ичида USDC билан тўлайди. Гаровли савдоларда харидор гаров қўяди — агар тўламаса, гаров сотувчига ўтади.",
    aboutSmartTitle: "Смарт контракт — инсон бошқармайди",
    aboutSmartDesc1: "Барча амаллар (эълон жойлаш, тасдиқлаш, тўлов, гаров қайтариш) тўлиқ смарт контракт томонидан бажарилади. Ҳеч қандай админ, owner ёки бошқарувчи йўқ — контракт автономдир.",
    aboutSmartDesc2: "Ҳеч ким контрактни тўхтата олмайди, токенларни ўғирлай олмайди ёки қоидаларни ўзгартира олмайди. Код бир марта deploy қилинган ва ўзгартирилмайди.",
    aboutHowTitle: "Қандай ишлайди?",
    aboutStep1Title: "1. Эълон жойлаш",
    aboutStep1Desc: "Сотувчи ёки харидор эълон жойлаштиради. Сотувчи DUR токенини ҳамёнидан контрактга беради.",
    aboutStep2Title: "2. Тасдиқлаш",
    aboutStep2Desc: "Иккинчи томон эълонни кўриб, тасдиқлайди. Гаровли савдоларда гаров токени ҳамёндан олинади. DUR харидорга берилади.",
    aboutStep3Title: "3. Тўлов",
    aboutStep3Desc: "Харидор белгиланган муддатда USDC билан тўлайди. Тўлов ҳамёндан тўғридан-тўғри сотувчига ўтади. Гаров қайтарилади.",
    aboutStep4Title: "4. Тўланмаса",
    aboutStep4Desc: "Муддат ўтгандан кейин сотувчи гаровни олади (гаровли) ёки харидорнинг БЛ даражаси 0 га тушади (гаровсиз).",
    aboutBLTitle: "БЛ (Business Level) тизими",
    aboutBLDesc: "БЛ — харидор ва сотувчи ўртасидаги ишонч даражаси. Ҳар бир муваффақиятли тўлов БЛ ни оширади:",
    aboutBLRow1Label: "Гаровли савдо",
    aboutBLRow1Value: "БЛ += DUR миқдори ÷ 10",
    aboutBLRow2Label: "Гаровсиз савдо",
    aboutBLRow2Value: "БЛ += DUR миқдори",
    aboutBLRow3Label: "Тўлов қилинмаса",
    aboutBLRow3Value: "Faqat o‘sha sotuvchi bilan BL = 0 bo‘ladi",
    aboutBLRow4Label: "Гаровсиз эълон учун",
    aboutBLRow4Value: "БЛ ≥ DUR × 10 керак",
    aboutTokensTitle: "Қўллаб-қувватланадиган токенлар",
    aboutTokenDUR: "Насия савдода сотиладиган асосий токен",
    aboutTokenUSDC: "Тўлов ва гаров учун барқарор токен",
    aboutTokenUSDT: "Гаров сифатида ишлатилиши мумкин",
    aboutTokenBLT: "Гаров токени, нархи Uniswap V4 дан ўқилади",
    aboutTokenWBTC: "Bitcoin ўрами, гаров сифатида",
    aboutTokenWETH: "Ethereum ўрами, гаров сифатида",
    aboutRoleTrade: "Савдо",
    aboutRolePayCol: "Тўлов / Гаров",
    aboutRoleCol: "Гаров",
    // Тарих саҳифаси
    txTitle: "Трансакция тарихи",
    txSubtitle: "Сизнинг трансакцияларингиз тарихи",
    txRefresh: "Янгилаш",
    txLoading: "Юкланмоқда...",
    txEmpty: "Ҳали трансакциялар йўқ",
    txEventCreated: "Эълон жойлаштирилди",
    txEventApproved: "Эълон тасдиқланди",
    txEventCancelled: "Эълон бекор қилинди",
    txEventPaid: "Тўлов амалга ошди",
    txEventCollateral: "Гаров қайтарилди",
    txEventBLClaimed: "Default claim qilindi",
    txLabelCreateListing: "Эълон жойлаш",
    txLabelListingApprove: "Эълон тасдиқлаш",
    txLabelListingCancel: "Эълон бекор қилиш",
    txLabelPayment: "Тўлов амалга оширилди",
    txLabelDefaultClaim: "Дефолт талаб қилинди",
    txLabelPayAfterDefault: "Қарз тўланди (дефолт кейин)",

    navSettings: "Созламалар",
    settingsTitle: "Созламалар",
    settingsSubtitle: "Эълон бериш созламалари. Бир марта белгиланг \u2014 ҳар эълон учун автоматик ишлатилади.",
    settingsDurationLabel: "Эълон муддати",
    settingsDurationDesc: "Янги эълон шу муддат ичида тасдиқланмаса, автоматик бекор бўлади. Default: 90 кун.",
    settingsDurationRange: "Оралиқ",
    settingsDays: "кун",
    settingsSaved: "Сақланди",
    settingsDeviationLabel: "Нарх фарқи чеклови",
    settingsDeviationDesc: "Эълонни тасдиқлаш вақтида бозор нархи лок нархидан шунча фоиздан кўп фарқланса, транзаксия автоматик бекор қилинади (flash loan ҳимояси). Default: 0.01%.",    clInfoDURFromWallet: "DUR токен (ҳамёндан)",

    settingsApproveMultLabel: "Approve миқдори",
    settingsApproveMultDesc: "Ҳар эълон учун қанча токен approve қилинсин. Юқори қиймат = келгуси эълонларда approve қайта сўралмайди (газ тежайди), лекин контрактга кўпроқ ишониш керак.",
    settingsApproveMult1: "1x (керакли)",
    settingsApproveMultMax: "Чексиз",
    settingsApproveMultMaxWarn: "Чексиз approve \u2014 контракт исталган вақтда шу токендан чексиз миқдор еча олади. Фақат ишончли контрактлар учун.",
    settingsRevokeLabel: "Барча approve'ларни бекор қилиш",
    settingsRevokeDesc: "Контрактга берилган барча токен рухсатларини 0 га туширади. Фақат рухсат берилган токенлар учун транзаксия юборилади (ҳар бири учун алоҳида тасдиқ). Хавфсизлик учун савдони тугатгандан кейин фойдаланинг.",
    settingsRevokeBtn: "Барчасини бекор қилиш",
    settingsRevoking: "Бекор қилинмоқда...",
    settingsRevokeChecking: "Approve'лар текширилмоқда...",
    settingsRevokeProgress: "бекор қилинмоқда...",
    settingsRevokeNone: "Бекор қилинадиган approve йўқ",
    settingsRevokeDone: "approve бекор қилинди",
    settingsRevokeRejected: "Бекор қилиш рад этилди",
    settingsRevokeConfirmQ: "Ишончингиз комилми? Ҳар бир токен учун алоҳида тасдиқ сўралади.",
    settingsRevokeConfirmYes: "Ҳа, бекор қил",
    settingsRevokeConfirmNo: "Йўқ",    clInfoCollateralOnApproval: "Танланган токенлардан гаров (тасдиқлашда олинади)",
    clInfoBuyerPaidCollateral: "USDC оласиз, харидорнинг БЛ даражаси ошади (DUR÷10)",
    clInfoBuyerNotPaidCollateral: "Гаровни оласиз, харидорнинг БЛ = 0",
    clInfoNoNeedBL: "Йўқ",
    clInfoCollateralTakenOnPost: "✅ Гаров токени ЭЪЛОН ПАЙТИДА ҳамёндан олинади",
    clInfoSellerDUROnApproval: "DUR токен (тасдиқлашда олинади)",
    clInfoYouPaidCollateral: "Гаров қайтади, сизнинг БЛ даражангиз ошади (DUR÷10)",
    clInfoYouNotPaidCollateral: "Гаров сотувчига, сизнинг БЛ = 0",
    clInfoOnlyBLNeeded: "Ҳеч нарса — фақат БЛ керак",
    clInfoBuyerPaidNoColl: "USDC оласиз, харидорнинг БЛ даражаси ошади (DUR миқдори)",
    clInfoBuyerNotPaidNoColl: "Ҳеч нарса йўқ — харидорнинг БЛ = 0",
    clInfoRiskHigh: "⚠️ Юқори",
    clInfoBLFromPrevious: "Аввалги гаровли савдолардан",
    clInfoYouPaidNoColl: "Сизнинг БЛ даражангиз ошади (DUR миқдорича)",
    clInfoYouNotPaidNoColl: "Сизнинг БЛ = 0 бўлади",
    clDURFromWalletAlert: "DUR ҳамёнингиздан олинади. Ҳамёнда:",
    clCollateralBuyWarningTitle: "Диққат!",
    clCollateralBuyWarning: "Эълон жойлаштирилганда гаров токени дарҳол ҳамёнингиздан контрактга ўтказилади. Сотувчи тасдиқлашидан олдин эълонни бекор қилсангиз гаров қайтарилади.",
    clSelectCollateralTokens: "Харидор қайси токенлардан гаров бера олади?",
    clCurrentPricePreview: "Ҳозирги нарх бўйича харидор қўйиши керак бўлган гаров миқдори:",
    clPriceLockWarning: "⚠ Эълон берилгач бу нархлар lock қилинади — тасдиқлаш вақтида бозор нархи ўзгарса ҳам шу миқдор олинади",
    clSelectCollateralToken: "Гаров токени танланг",
    clTokenTakenOnPost: "(эълон пайтида ҳамёндан олинади)",
    clRequiredCollateral: "Керакли гаров миқдори:",
    clWalletBalance: "Ҳамёнда:",
    clInsufficientToken: "— етарли эмас!",
    clEnterDUR: "DUR миқдорини киритинг!",
    clEnterPrice: "Нархни киритинг!",
    clEnterPeriod: "Тўлов муддатини киритинг!",
    clSelectOneToken: "Камида битта гаров токени танланг!",
    clDURInsufficient: "DUR етарли эмас! Ҳамёнда:",
    clTokenInsufficient: "етарли эмас! Ҳамёнда:",
    clTokenNeeded: "керак:",
    clWalletInsufficient: "Ҳамёнда етарли токен йўқ!",
    clZeroCollateral: "Гаров миқдори нол — нархни текширинг!",
    clPaymentProcessing: "Тўлов амалга оширилмоқда...",
    approvedUSDCAlert: "Тўлов учун USDC ҳамёнингиздан олинади. Ҳамёнда:",
    approvedRefresh: "Янгилаш",
    approvedCollateralLabel: "Гаров:",
    approvedUSDCInsufficient: "USDC етарли эмас!",
    dashActiveUsers: "Фаол иштирокчилар",
    dashActiveUsersDesc: "Ноёб манзиллар",
    searchPlaceholder: "ИД, манзил ёки миқдор...",
    filterAll: "Барчаси",
  },
  ru: {
    appName: "NasiyaSale",
    network: "ОП Мейннет",
    // ── Vault ──────────────────────────────────────────────────
    vaultTitle: "Vault",
    vaultOwnerPanel: "Панель владельца активна",
    vaultRefresh: "Обновить",
    vaultActiveLocks: "Активные локи",
    vaultNFTLocks: "NFT локи",
    vaultFaolNFTLocks: "Активные NFT локи",
    vaultFaolNFTLockYoq: "Активных NFT локов нет",
    vaultBalances: "Балансы Vault",
    vaultActiveLocksList: "Активные токен локи",
    vaultNFTLocksList: "NFT (LP) локи",
    vaultLPValue: "Стоимость LP",
    vaultUnlockDate: "Дата разблокировки",
    vaultDeposited: "Внесено",
    vaultStatus: "Статус",
    vaultActive: "Активен",
    vaultUnlocked: "Разблокирован",
    vaultWithdrawn: "Выведен",
    vaultEmergency: "Экстренный",
    vaultRebalanced: "Rebalanced",
    vaultEmergencyReady: "Экстренный вывод доступен",
    vaultEmergencyIn: "Экстренный:",
    vaultWithdraw: "Вывести",
    vaultEmergencyBtn: "Emergency",
    vaultRebalanceBtn: "Rebalance",
    vaultNoLocks: "Локи не найдены",
    vaultNoNFT: "NFT локи не найдены",
    vaultNoHistory: "История пуста",
    vaultTokenHistory: "История токен локов",
    vaultNFTHistory: "История NFT локов",
    vaultStatistics: "Статистика",
    vaultTotalLocks: "Всего локов",
    vaultTotalNFT: "Всего NFT",
    vaultWithdrawalAddress: "Адрес вывода",
    vaultPrices: "Цены и управление",
    vaultCurrentPrices: "Текущие цены",
    vaultUpdatePrices: "Обновить цены",
    vaultSyncBalance: "Синхронизация баланса",
    vaultSync: "Синхронизировать",
    vaultNFTRebalance: "NFT Rebalance",
    vaultOldNFTLockId: "ID старого NFT лока",
    vaultNewNFTTokenId: "ID нового NFT токена",
    vaultOldNFTHint: "Номер лока из вкладки NFT",
    vaultNewNFTHint: "ID новой LP позиции",
    vaultRebalance: "Rebalance",
    vaultDepositToken: "Заблокировать токен",
    vaultDepositNFT: "Заблокировать NFT",
    vaultNFTId: "NFT Token ID",
    vaultNFTDays: "Срок блокировки (дней)",
    vaultNFTDaysHint: "Минимум 1 день",
    vaultLockDate: "Дата разблокировки",
    vaultLockBtn: "Заблокировать",
    vaultApproveBtn: "Разрешить (Approve)",
    vaultNFTLockBtn: "Заблокировать NFT",
    vaultSelectToken: "Выберите токен",
    vaultAmount: "Сумма",
    vaultDays: "Срок (дней)",
    vaultBalance: "Баланс",
    vaultSearch: "Поиск...",
    vaultTabStatistika: "Статистика",
    vaultTabLocklar: "Локи",
    vaultTabNFT: "NFT",
    vaultTabTarix: "История",
    vaultTabKiritish: "Внести",
    vaultTabBoshqaruv: "Управление",
    vaultWalletNotConnected: "Кошелёк не подключён",
    vaultEnterAmount: "Введите сумму",
    vaultEnterDays: "Введите количество дней",
    vaultInsufficientBalance: "Недостаточно средств",
    vaultApproving: "Approve...",
    vaultApproveSuccess: "Approve выполнен!",
    vaultLocking: "Блокировка...",
    vaultLockSuccess: "дней заблокировано!",
    vaultLoadError: "Ошибка загрузки Vault",
    vaultWithdrawing: "Вывод...",
    vaultSuccess: "Успешно!",
    vaultNFTWithdrawing: "Вывод NFT...",
    vaultNFTWithdrawn: "NFT выведен!",
    vaultNFTApproving: "Approve NFT...",
    vaultNFTLocking: "Блокировка NFT...",
    vaultNFTLocked: "дней заблокировано!",
    vaultRebalancing: "Rebalance...",
    vaultRebalanceSuccess: "Rebalance выполнен!",
    vaultBLTUpdating: "Цена BLT...",
    vaultDURUpdating: "Цена DUR...",
    vaultPricesUpdated: "Цены обновлены!",
    vaultSyncing: "Синхронизация...",
    vaultSyncSuccess: "Баланс синхронизирован!",
    vaultRebalanceSelected: "выбран. Введите ID нового NFT.",
    vaultUnknownError: "Неизвестная ошибка",
    vaultReady: "Готово",
    navDashboard: "Главная",
    navAbout: "О платформе",
    navCreate: "Разместить объявление",
    navListings: "Объявления",
    navApproved: "Подтверждённые",
    navBL: "Уровень BL",
    navHistory: "История",
    connect: "Подключить кошелёк",
    disconnect: "Выйти",
    wrongNetwork: "Неверная сеть",
    switchNetwork: "Переключить на Arbitrum",
    walletMetaMask: "MetaMask",
    walletMetaMaskDesc: "Через расширение браузера",
    walletTrust: "Trust Wallet / Другой кошелёк",
    walletTrustDesc: "WalletConnect — 300+ кошельков",
    walletView: "Просмотр по адресу",
    walletViewDesc: "Только просмотр — без транзакций",
    walletViewWarning: "В этом режиме только просмотр. Для транзакций нужен MetaMask.",
    walletAddress: "Адрес кошелька (0x...)",
    walletViewBtn: "Войти в режиме просмотра",
    walletReadOnly: "👁 Режим просмотра",
    walletChecking: "Проверка...",
    walletConnected: "Кошелёк подключён! ✓",
    walletDisconnected: "Кошелёк отключён",
    walletRejected: "Отклонено",
    walletWCStep1: "Откройте Trust Wallet или другой кошелёк на телефоне",
    walletWCStep2: "Нажмите 'WalletConnect' в приложении",
    walletWCStep3: "Введите адрес сайта или отсканируйте QR",
    walletWCStep4: "Подтвердите подключение",
    walletWCNote: "Полная интеграция WalletConnect будет добавлена в следующей версии.",
    walletTitle: "Подключить кошелёк",
    walletSubtitle: "Выберите способ подключения",
    walletMobileTitle: "Подключение мобильного кошелька",
    dashTitle: "Главная",
    dashSubtitle: "Состояние платформы и ваши депозиты",
    dashWelcome: "Добро пожаловать в NasiyaSale",
    dashWelcomeDesc: "Платформа для покупки и продажи токенов DUR в кредит. Подключите кошелёк для начала.",
    dashDeposits: "Депозиты контракта",
    dashWalletBal: "Кошелёк",
    dashStats: "Статистика платформы",
    dashSellerL: "Объявления продавцов",
    dashBuyerR: "Запросы покупателей",
    dashApprovedS: "Подтверждённые",
    dashPending: "Ожидающие объявления",
    dashPendingR: "Ожидающие запросы",
    dashActive: "Активные контракты",
    dashActions: "Быстрые действия",
    dashDepositT: "Пополнить депозит",
    dashDepositD: "Внесите токены DUR, USDC или BLT в контракт",
    dashCreateT: "Разместить объявление",
    dashCreateD: "Разместите новое объявление о кредитной продаже",
    dashListingsT: "Список объявлений",
    dashListingsD: "Просматривайте и подтверждайте объявления",
    dashApprovedT: "Подтверждённые контракты",
    dashApprovedD: "Совершите оплату или верните залог",
    depositTitle: "Депозит",
    depositSubtitle: "Внесите токены в контракт",
    depositBtn: "Депозит",
    depositWallet: "Баланс кошелька",
    depositContract: "Депозит контракта",
    depositNote: "При первом депозите нужно подтвердить разрешение (approve) — это одноразовое действие.",
    depositDURDesc: "Основной токен для кредитной торговли",
    depositUSDCDesc: "Стабильный токен для оплаты",
    depositBLTDesc: "Токен используемый как залог",
    createTitle: "Разместить объявление",
    createSubtitle: "Разместите объявление для торговли DUR в кредит",
    createSelectType: "Выберите тип объявления",
    createAbout: "О данном типе",
    createDUR: "Количество DUR",
    createPrice: "Сумма оплаты (USDC)",
    createPeriod: "Срок оплаты (дней)",
    createPeriodNote: "Начиная с даты подтверждения,",
    createPeriodNote2: "дней на оплату",
    createBtn: "Разместить объявление",
    createPosting: "Размещение...",
    createDURDeposit: "Ваш депозит DUR:",
    createBLTDeposit: "Ваш депозит BLT:",
    createRequiredBL: "Требуемый BL:",
    createBLTCollateral: "Залог BLT:",
    createSuccess: "Объявление успешно размещено!",
    createRejected: "Отклонено",
    createNoDUR: "Недостаточно DUR на депозите!",
    createNoBLT: "Недостаточно BLT на депозите!",
    createFillAll: "Заполните все поля!",
    createSelectErr: "Выберите тип!",
    lt1Title: "Продавец — С залогом",
    lt1Desc: "Вы продаёте DUR, покупатель вносит залог",
    lt2Title: "Покупатель — С залогом",
    lt2Desc: "Вы покупаете DUR, вносите залог",
    lt3Title: "Продавец — Без залога",
    lt3Desc: "Вы продаёте DUR, покупатель должен иметь уровень BL",
    lt4Title: "Покупатель — Без залога",
    lt4Desc: "Вы покупаете DUR, нужен ваш уровень BL",
    infoYouPut: "Что вы вносите?",
    infoBuyerPut: "Что вносит покупатель?",
    infoSellerPut: "Что вносит продавец?",
    infoIfPaid: "Если вы заплатите?",
    infoBuyerPaid: "Если покупатель заплатит?",
    infoIfNotPaid: "Если вы не заплатите?",
    infoBuyerNotPaid: "Если покупатель не заплатит?",
    infoNeedBL: "Нужен ли BL?",
    infoRisk: "Уровень риска?",
    infoRequiredBL: "Требуемый уровень BL?",
    infoWhereBL: "Откуда берётся BL?",
    listingsTitle: "Объявления",
    listingsSubtitle: "Ожидающие объявления кредитной торговли",
    listingsSellerTab: "Объявления продавцов",
    listingsBuyerTab: "Запросы покупателей",
    listingsEmpty: "Объявлений пока нет",
    listingsApprove: "Подтвердить",
    listingsApproving: "Подтверждение...",
    listingsApproved: "Объявление подтверждено!",
    listingsColID: "ID",
    listingsColType: "Тип",
    listingsColAmount: "DUR / USDC",
    listingsColSeller: "Продавец",
    listingsColBuyer: "Покупатель",
    listingsColPeriod: "Срок",
    listingsColStatus: "Статус",
    listingsColAction: "Действие",
    listingsCollateral: "С залогом",
    listingsNoCollateral: "Без залога",
    listingsYours: "Ваше",
    listingsNoDURDep: "Недостаточно DUR на депозите",
    listingsNoBLTDep: "Недостаточно BLT на депозите",
    listingsLowBL: "Недостаточный уровень BL у покупателя",
    approvedTitle: "Подтверждённые контракты",
    approvedSubtitle: "Активные контракты кредитной торговли",
    approvedEmpty: "Нет активных контрактов",
    approvedUSDCWarn: "Ваш депозит USDC:",
    approvedUSDCWarn2: "Для оплаты сначала пополните депозит USDC.",
    approvedPay: "Оплатить",
    approvedClaimCol: "Default claim qilish",
    approvedClaimBL: "Default claim qilish",
    approvedYouBuyer: "Вы покупатель",
    approvedYouSeller: "Вы продавец",
    approvedExpired: "Срок истёк",
    approvedTimeLeft: "осталось",
    approvedDays: "дн",
    approvedHours: "ч",
    approvedPaySuccess: "Оплата успешно выполнена!",
    approvedClaimColSuccess: "Default claim muvaffaqiyatli bajarildi!",
    approvedClaimBLSuccess: "Default claim muvaffaqiyatli bajarildi!",
    approvedNoUSDC: "Недостаточно USDC на депозите",
    approvedDeadline: "Срок истёк",
    approvedClaimDefault: "Default claim qilish",
    approvedClaimDefaultSuccess: "Default claim muvaffaqiyatli bajarildi!",
    statusDefaulted: "Default / to‘lanmagan",
    payAfterDefault: "Keyin to‘lash",
    payAfterDefaultSuccess: "Default qarz to‘landi!",
    blacklistedWarning: "Siz qora ro‘yxatdasiz. Garovsiz sotib ololmaysiz.",
    unpaidDefaultLeft: "To‘lanmagan defaultlar",
    blTitle: "Уровень BL",
    blSubtitle: "Проверьте уровень доверия покупателя и продавца",
    blBuyer: "Адрес покупателя",
    blSeller: "Адрес продавца",
    blMe: "Я",
    blCheck: "Проверить BL",
    blChecking: "Проверка...",
    blTotal: "Общий уровень BL",
    blTotalDesc: "Общее доверие накопленное покупателем",
    blBusy: "Занятый BL",
    blBusyDesc: "Занято для ожидающих запросов",
    blFree: "Свободный BL",
    blFreeDesc: "Доступно для новых сделок",
    blNote: "При торговле без залога покупатель должен иметь BL = количество DUR × 10.",
    blFillBoth: "Введите оба адреса!",
    blInvalidAddr: "Неверный формат адреса!",
    blMyAddr: "Мой адрес",
    blResultLevel: "Уровень BL",
    blResultBusy: "Занятый BL",
    blResultFree: "Свободный BL",
    blExplanation: "Уровень BL растёт при оплате залоговых сделок (DUR÷10) и без залога (на сумму DUR). При неоплате BL обнуляется.",
    blBuyerAddress: "Адрес покупателя",
    blSellerAddress: "Адрес продавца (опционально)",
    blSearching: "Поиск...",
    blSearch: "Поиск",
    blTotalLevel: "Общий уровень BL",
    blTotalBL: "Total BL",
    blPendingBL: "Зарезервированный BL",
    blFreeTotal: "Свободный общий BL",
    blPairwise: "Pairwise BL с этим продавцом",
    blActiveExposure: "Активный долг без залога (с этим продавцом)",
    blBlacklist: "Чёрный список",
    blYes: "Да",
    blNo: "Нет",
    blUnpaidNoCollateral: "Неоплаченные долги без залога",
    blUnpaidDefault: "Всего неоплаченных долгов",
    blInfo: "При подтверждении объявления без залога контракт чаще всего проверяет не общий BL, а pairwise BL с продавцом или свободный общий BL.",
    historyTitle: "История транзакций",
    historySubtitle: "Ваши последние действия",
    historyClear: "Очистить",
    historyEmpty: "Транзакций пока нет",
    historyEmptyDesc: "Здесь будут отображаться ваши действия",
    historyExplorer: "Explorer",
    historyListing: "Объявление",
    historyRole: "Роль",
    historyNewBL: "Новый BL:",
    historyBLT: "BLT:",
    historyCreated: "Объявление размещено",
    historyApproved: "Объявление подтверждено",
    historyPaid: "Оплата выполнена",
    historyCollateral: "Залог возвращён",
    historyBLClaimed: "Default claim qilindi",
    historyBuyer: "покупатель",
    historySeller: "продавец",
    historySecondsAgo: "секунд назад",
    historyMinutesAgo: "минут назад",
    historyHoursAgo: "часов назад",
    historyDaysAgo: "дней назад",
    statusPendingSellerC: "Продавец ждёт (с залогом)",
    statusPendingBuyerC: "Покупатель ждёт (с залогом)",
    statusPendingSellerN: "Продавец ждёт (без залога)",
    statusPendingBuyerN: "Покупатель ждёт (без залога)",
    statusApproved: "Подтверждено",
    statusRemoved: "Отменено",
    statusPaid: "Оплачено",
    statusClaimCol: "Default",
    statusClaimBL: "Default",
    // Tokenomics
    tokenSubtitle: "Полная информация о токенах DUR и BLT — предложение, lock и рыночная стоимость",
    tokenTotalSupply: "Общее предложение",
    tokenCirculating: "В обращении",
    tokenLocked: "Заблокировано",
    tokenPrice: "Цена",
    tokenDistribution: "Общее распределение",
    tokenAbout: "О проекте",
    tokenAddresses: "Адреса токенов",
    connectPrompt: "Подключите кошелёк для транзакций",
    aboutDoc: "Документ",
    noData: "Нет данных",
    errorOccurred: "Произошла ошибка",
    days: "дн",
    // О платформе
    aboutPageTitle: "О платформе",
    aboutPageSubtitle: "NasiyaSale — децентрализованная платформа кредитной торговли",
    aboutWhatIs: "Что такое NasiyaSale?",
    aboutWhatIsDesc1: "NasiyaSale — это децентрализованная платформа, разработанная для покупки и продажи токена DUR в кредит. Все сделки выполняются через смарт-контракт без посредников и управляющих.",
    aboutWhatIsDesc2: "Продавец размещает токены DUR, покупатель берёт их в кредит и оплачивает в установленный срок в USDC. При залоговых сделках покупатель вносит залог — если не заплатит, залог переходит продавцу.",
    aboutSmartTitle: "Смарт-контракт — без человеческого управления",
    aboutSmartDesc1: "Все действия (размещение объявления, подтверждение, оплата, возврат залога) полностью выполняются смарт-контрактом. Нет администратора, владельца или управляющего — контракт автономен.",
    aboutSmartDesc2: "Никто не может остановить контракт, украсть токены или изменить правила. Код развёрнут один раз и не подлежит изменению.",
    aboutHowTitle: "Как это работает?",
    aboutStep1Title: "1. Размещение объявления",
    aboutStep1Desc: "Продавец или покупатель размещает объявление. Продавец передаёт токены DUR из кошелька в контракт.",
    aboutStep2Title: "2. Подтверждение",
    aboutStep2Desc: "Вторая сторона просматривает объявление и подтверждает. При залоговых сделках залоговый токен списывается из кошелька. DUR передаётся покупателю.",
    aboutStep3Title: "3. Оплата",
    aboutStep3Desc: "Покупатель оплачивает в USDC в установленный срок. Оплата поступает напрямую из кошелька продавцу. Залог возвращается.",
    aboutStep4Title: "4. Если не оплачено",
    aboutStep4Desc: "После истечения срока продавец забирает залог (залоговая) или уровень BL покупателя обнуляется (без залога).",
    aboutBLTitle: "Система BL (Business Level)",
    aboutBLDesc: "BL — уровень доверия между покупателем и продавцом. Каждый успешный платёж увеличивает BL:",
    aboutBLRow1Label: "Залоговая сделка",
    aboutBLRow1Value: "BL += кол-во DUR ÷ 10",
    aboutBLRow2Label: "Без залога",
    aboutBLRow2Value: "BL += кол-во DUR",
    aboutBLRow3Label: "Неоплата",
    aboutBLRow3Value: "Faqat o‘sha sotuvchi bilan BL = 0 bo‘ladi",
    aboutBLRow4Label: "Для объявления без залога",
    aboutBLRow4Value: "BL ≥ DUR × 10 необходим",
    aboutTokensTitle: "Поддерживаемые токены",
    aboutTokenDUR: "Основной токен для кредитной торговли",
    aboutTokenUSDC: "Стабильный токен для оплаты и залога",
    aboutTokenUSDT: "Может использоваться как залог",
    aboutTokenBLT: "Залоговый токен, цена из Uniswap V4",
    aboutTokenWBTC: "Обёртка Bitcoin, для залога",
    aboutTokenWETH: "Обёртка Ethereum, для залога",
    aboutRoleTrade: "Торговля",
    aboutRolePayCol: "Оплата / Залог",
    aboutRoleCol: "Залог",
    // История транзакций
    txTitle: "История транзакций",
    txSubtitle: "История ваших транзакций",
    txRefresh: "Обновить",
    txLoading: "Загрузка...",
    txEmpty: "Транзакций пока нет",
    txEventCreated: "Объявление размещено",
    txEventApproved: "Объявление подтверждено",
    txEventCancelled: "Объявление отменено",
    txEventPaid: "Оплата выполнена",
    txEventCollateral: "Залог возвращён",
    txEventBLClaimed: "Default claim qilindi",
    txLabelCreateListing: "Создание объявления",
    txLabelListingApprove: "Подтверждение объявления",
    txLabelListingCancel: "Отмена объявления",
    txLabelPayment: "Платёж выполнен",
    txLabelDefaultClaim: "Дефолт затребован",
    txLabelPayAfterDefault: "Долг погашен (после дефолта)",

    navSettings: "Настройки",
    settingsTitle: "Настройки",
    settingsSubtitle: "Настройки создания объявлений. Задайте один раз \u2014 применяется автоматически к каждому объявлению.",
    settingsDurationLabel: "Срок объявления",
    settingsDurationDesc: "Если объявление не подтверждено в этот срок, оно автоматически отменяется. По умолчанию: 90 дней.",
    settingsDurationRange: "Диапазон",
    settingsDays: "дн.",
    settingsSaved: "Сохранено",
    settingsDeviationLabel: "Лимит отклонения цены",
    settingsDeviationDesc: "Если при подтверждении рыночная цена отклоняется от зафиксированной более чем на этот процент, транзакция автоматически отменяется (защита от flash loan). По умолчанию: 3%.",    clInfoDURFromWallet: "Токен DUR (из кошелька)",

    settingsApproveMultLabel: "Сумма approve",
    settingsApproveMultDesc: "Сколько токенов одобрять для каждого объявления. Большее значение = approve не запрашивается повторно (экономит газ), но требует большего доверия к контракту.",
    settingsApproveMult1: "1x (точно)",
    settingsApproveMultMax: "Бесконечно",
    settingsApproveMultMaxWarn: "Бесконечный approve \u2014 контракт сможет в любой момент списать неограниченное количество этого токена. Только для доверенных контрактов.",
    settingsRevokeLabel: "Отозвать все approve",
    settingsRevokeDesc: "Сбрасывает все разрешения токенов, выданные контракту, до 0. Транзакция отправляется только для токенов с разрешением (отдельное подтверждение для каждого). Используйте после завершения торговли для безопасности.",
    settingsRevokeBtn: "Отозвать все",
    settingsRevoking: "Отзыв...",
    settingsRevokeChecking: "Проверка approve...",
    settingsRevokeProgress: "отзыв...",
    settingsRevokeNone: "Нет approve для отзыва",
    settingsRevokeDone: "approve отозвано",
    settingsRevokeRejected: "Отзыв отклонён",
    settingsRevokeConfirmQ: "Вы уверены? Для каждого токена будет запрошено отдельное подтверждение.",
    settingsRevokeConfirmYes: "Да, отозвать",
    settingsRevokeConfirmNo: "Нет",    clInfoCollateralOnApproval: "Залог из выбранных токенов (берётся при подтверждении)",
    clInfoBuyerPaidCollateral: "Получите USDC, уровень BL покупателя вырастет (DUR÷10)",
    clInfoBuyerNotPaidCollateral: "Получите залог, BL покупателя = 0",
    clInfoNoNeedBL: "Нет",
    clInfoCollateralTakenOnPost: "✅ Залоговый токен берётся ПРИ РАЗМЕЩЕНИИ из кошелька",
    clInfoSellerDUROnApproval: "Токен DUR (берётся при подтверждении)",
    clInfoYouPaidCollateral: "Залог возвращается, ваш BL вырастет (DUR÷10)",
    clInfoYouNotPaidCollateral: "Залог уходит продавцу, ваш BL = 0",
    clInfoOnlyBLNeeded: "Ничего — нужен только BL",
    clInfoBuyerPaidNoColl: "Получите USDC, BL покупателя вырастет (на сумму DUR)",
    clInfoBuyerNotPaidNoColl: "Ничего — BL покупателя = 0",
    clInfoRiskHigh: "⚠️ Высокий",
    clInfoBLFromPrevious: "Из предыдущих залоговых сделок",
    clInfoYouPaidNoColl: "Ваш BL вырастет (на сумму DUR)",
    clInfoYouNotPaidNoColl: "Ваш BL станет 0",
    clDURFromWalletAlert: "DUR будет списан из кошелька. В кошельке:",
    clCollateralBuyWarningTitle: "Внимание!",
    clCollateralBuyWarning: "При размещении объявления залоговый токен сразу переводится из кошелька в контракт. Если отмените до подтверждения продавцом — залог вернётся.",
    clSelectCollateralTokens: "Какими токенами покупатель может внести залог?",
    clCurrentPricePreview: "По текущей цене покупатель должен внести залог:",
    clPriceLockWarning: "⚠ После размещения цены фиксируются — при подтверждении берётся эта сумма, даже если рыночная цена изменится",
    clSelectCollateralToken: "Выберите залоговый токен",
    clTokenTakenOnPost: "(берётся из кошелька при размещении)",
    clRequiredCollateral: "Требуемый залог:",
    clWalletBalance: "В кошельке:",
    clInsufficientToken: "— недостаточно!",
    clEnterDUR: "Введите количество DUR!",
    clEnterPrice: "Введите цену!",
    clEnterPeriod: "Введите срок оплаты!",
    clSelectOneToken: "Выберите хотя бы один залоговый токен!",
    clDURInsufficient: "Недостаточно DUR! В кошельке:",
    clTokenInsufficient: "недостаточно! В кошельке:",
    clTokenNeeded: "нужно:",
    clWalletInsufficient: "Недостаточно токенов в кошельке!",
    clZeroCollateral: "Сумма залога равна нулю — проверьте цену!",
    clPaymentProcessing: "Выполняется оплата...",
    approvedUSDCAlert: "Оплата производится USDC из кошелька. В кошельке:",
    approvedRefresh: "Обновить",
    approvedCollateralLabel: "Залог:",
    approvedUSDCInsufficient: "Недостаточно USDC!",
    dashActiveUsers: "Активные участники",
    dashActiveUsersDesc: "Уникальные адреса",
    searchPlaceholder: "ID, адрес или сумма...",
    filterAll: "Все",
  },
  en: {
    appName: "NasiyaSale",
    network: "Arbitrum One",
    // ── Vault ──────────────────────────────────────────────────
    vaultTitle: "Vault",
    vaultOwnerPanel: "Owner panel active",
    vaultRefresh: "Refresh",
    vaultActiveLocks: "Active locks",
    vaultNFTLocks: "NFT locks",
    vaultFaolNFTLocks: "Active NFT locks",
    vaultFaolNFTLockYoq: "No active NFT locks",
    vaultBalances: "Vault balances",
    vaultActiveLocksList: "Active token locks",
    vaultNFTLocksList: "NFT (LP) locks",
    vaultLPValue: "LP value",
    vaultUnlockDate: "Unlock date",
    vaultDeposited: "Deposited",
    vaultStatus: "Status",
    vaultActive: "Active",
    vaultUnlocked: "Unlocked",
    vaultWithdrawn: "Withdrawn",
    vaultEmergency: "Emergency",
    vaultRebalanced: "Rebalanced",
    vaultEmergencyReady: "Emergency ready",
    vaultEmergencyIn: "Emergency in:",
    vaultWithdraw: "Withdraw",
    vaultEmergencyBtn: "Emergency",
    vaultRebalanceBtn: "Rebalance",
    vaultNoLocks: "No locks found",
    vaultNoNFT: "No NFT locks found",
    vaultNoHistory: "No history yet",
    vaultTokenHistory: "Token lock history",
    vaultNFTHistory: "NFT lock history",
    vaultStatistics: "Statistics",
    vaultTotalLocks: "Total locks",
    vaultTotalNFT: "Total NFT",
    vaultWithdrawalAddress: "Withdrawal address",
    vaultPrices: "Prices & management",
    vaultCurrentPrices: "Current prices",
    vaultUpdatePrices: "Update prices",
    vaultSyncBalance: "Sync balance",
    vaultSync: "Sync",
    vaultNFTRebalance: "NFT Rebalance",
    vaultOldNFTLockId: "Old NFT lock ID",
    vaultNewNFTTokenId: "New NFT Token ID",
    vaultOldNFTHint: "Lock number from NFT tab",
    vaultNewNFTHint: "Newly created LP position ID",
    vaultRebalance: "Rebalance",
    vaultDepositToken: "Lock token",
    vaultDepositNFT: "Lock NFT",
    vaultNFTId: "NFT Token ID",
    vaultNFTDays: "Lock period (days)",
    vaultNFTDaysHint: "Min 1 day, max 5475 days",
    vaultLockDate: "Unlock date",
    vaultLockBtn: "Lock",
    vaultApproveBtn: "Approve",
    vaultNFTLockBtn: "Lock NFT",
    vaultSelectToken: "Select token",
    vaultAmount: "Amount",
    vaultDays: "Period (days)",
    vaultBalance: "Balance",
    vaultSearch: "Search...",
    vaultTabStatistika: "Statistics",
    vaultTabLocklar: "Locks",
    vaultTabNFT: "NFT",
    vaultTabTarix: "History",
    vaultTabKiritish: "Deposit",
    vaultTabBoshqaruv: "Management",
    vaultWalletNotConnected: "Wallet not connected",
    vaultEnterAmount: "Enter amount",
    vaultEnterDays: "Enter number of days",
    vaultInsufficientBalance: "Insufficient balance",
    vaultApproving: "Approving...",
    vaultApproveSuccess: "Approved!",
    vaultLocking: "Locking...",
    vaultLockSuccess: "days locked!",
    vaultLoadError: "Error loading Vault",
    vaultWithdrawing: "Withdrawing...",
    vaultSuccess: "Success!",
    vaultNFTWithdrawing: "Withdrawing NFT...",
    vaultNFTWithdrawn: "NFT withdrawn!",
    vaultNFTApproving: "Approving NFT...",
    vaultNFTLocking: "Locking NFT...",
    vaultNFTLocked: "days locked!",
    vaultRebalancing: "Rebalancing...",
    vaultRebalanceSuccess: "Rebalance complete!",
    vaultBLTUpdating: "BLT price...",
    vaultDURUpdating: "DUR price...",
    vaultPricesUpdated: "Prices updated!",
    vaultSyncing: "Syncing...",
    vaultSyncSuccess: "Balance synced!",
    vaultRebalanceSelected: "selected. Enter new NFT Token ID.",
    vaultUnknownError: "Unknown error",
    vaultReady: "Ready",
    navDashboard: "Dashboard",
    navAbout: "About",
    navCreate: "Post Listing",
    navListings: "Listings",
    navApproved: "Approved",
    navBL: "BL Level",
    navHistory: "History",
    connect: "Connect Wallet",
    disconnect: "Disconnect",
    wrongNetwork: "Wrong Network",
    switchNetwork: "Switch to Arbitrum",
    walletMetaMask: "MetaMask",
    walletMetaMaskDesc: "Via browser extension",
    walletTrust: "Trust Wallet / Other",
    walletTrustDesc: "WalletConnect — 300+ wallets",
    walletView: "View by Address",
    walletViewDesc: "Read-only mode — no transactions",
    walletViewWarning: "Read-only mode. MetaMask required for transactions.",
    walletAddress: "Wallet address (0x...)",
    walletViewBtn: "Enter read-only mode",
    walletReadOnly: "👁 Read-only",
    walletChecking: "Checking...",
    walletConnected: "Wallet connected! ✓",
    walletDisconnected: "Wallet disconnected",
    walletRejected: "Rejected",
    walletWCStep1: "Open Trust Wallet or another wallet app on your phone",
    walletWCStep2: "Tap 'WalletConnect' in the app",
    walletWCStep3: "Enter the site URL or scan the QR code",
    walletWCStep4: "Confirm the connection",
    walletWCNote: "Full WalletConnect integration coming in the next version.",
    walletTitle: "Connect Wallet",
    walletSubtitle: "Choose a connection method",
    walletMobileTitle: "Connect Mobile Wallet",
    dashTitle: "Dashboard",
    dashSubtitle: "Platform status and your deposits",
    dashWelcome: "Welcome to NasiyaSale",
    dashWelcomeDesc: "A platform for buying and selling DUR tokens on credit. Connect your wallet to get started.",
    dashDeposits: "Contract Deposits",
    dashWalletBal: "Wallet",
    dashStats: "Platform Statistics",
    dashSellerL: "Seller Listings",
    dashBuyerR: "Buyer Requests",
    dashApprovedS: "Approved",
    dashPending: "Pending listings",
    dashPendingR: "Pending requests",
    dashActive: "Active contracts",
    dashActions: "Quick Actions",
    dashDepositT: "Add Deposit",
    dashDepositD: "Deposit DUR, USDC or BLT tokens into the contract",
    dashCreateT: "Post Listing",
    dashCreateD: "Post a new credit sale listing",
    dashListingsT: "Listings",
    dashListingsD: "View and approve pending listings",
    dashApprovedT: "Approved Contracts",
    dashApprovedD: "Make payment or claim collateral",
    depositTitle: "Deposit",
    depositSubtitle: "Deposit tokens into the contract",
    depositBtn: "Deposit",
    depositWallet: "Wallet Balance",
    depositContract: "Contract Deposit",
    depositNote: "First deposit requires a one-time token approval (approve).",
    depositDURDesc: "Main token used for credit trading",
    depositUSDCDesc: "Stable token used for payments",
    depositBLTDesc: "Token used as collateral",
    createTitle: "Post Listing",
    createSubtitle: "Post a DUR credit sale listing",
    createSelectType: "Select listing type",
    createAbout: "About this type",
    createDUR: "DUR amount",
    createPrice: "Payment amount (USDC)",
    createPeriod: "Payment period (days)",
    createPeriodNote: "Starting from approval date,",
    createPeriodNote2: "days to pay",
    createBtn: "Post Listing",
    createPosting: "Posting...",
    createDURDeposit: "Your DUR deposit:",
    createBLTDeposit: "Your BLT deposit:",
    createRequiredBL: "Required BL:",
    createBLTCollateral: "BLT collateral:",
    createSuccess: "Listing posted successfully!",
    createRejected: "Rejected",
    createNoDUR: "Insufficient DUR deposit!",
    createNoBLT: "Insufficient BLT deposit!",
    createFillAll: "Fill in all fields!",
    createSelectErr: "Select a type!",
    lt1Title: "Seller — With Collateral",
    lt1Desc: "You sell DUR, buyer deposits collateral",
    lt2Title: "Buyer — With Collateral",
    lt2Desc: "You buy DUR, deposit collateral",
    lt3Title: "Seller — No Collateral",
    lt3Desc: "You sell DUR, buyer needs BL level",
    lt4Title: "Buyer — No Collateral",
    lt4Desc: "You buy DUR, you need BL level",
    infoYouPut: "What do you deposit?",
    infoBuyerPut: "What does the buyer deposit?",
    infoSellerPut: "What does the seller deposit?",
    infoIfPaid: "If you pay?",
    infoBuyerPaid: "If buyer pays?",
    infoIfNotPaid: "If you don't pay?",
    infoBuyerNotPaid: "If buyer doesn't pay?",
    infoNeedBL: "Is BL required?",
    infoRisk: "Risk level?",
    infoRequiredBL: "Required BL amount?",
    infoWhereBL: "Where does BL come from?",
    listingsTitle: "Listings",
    listingsSubtitle: "Pending credit sale listings",
    listingsSellerTab: "Seller Listings",
    listingsBuyerTab: "Buyer Requests",
    listingsEmpty: "No listings yet",
    listingsApprove: "Approve",
    listingsApproving: "Approving...",
    listingsApproved: "Listing approved!",
    listingsColID: "ID",
    listingsColType: "Type",
    listingsColAmount: "DUR / USDC",
    listingsColSeller: "Seller",
    listingsColBuyer: "Buyer",
    listingsColPeriod: "Period",
    listingsColStatus: "Status",
    listingsColAction: "Action",
    listingsCollateral: "Collateral",
    listingsNoCollateral: "No Collateral",
    listingsYours: "Yours",
    listingsNoDURDep: "Insufficient DUR deposit",
    listingsNoBLTDep: "Insufficient BLT deposit",
    listingsLowBL: "Buyer has insufficient BL level",
    approvedTitle: "Approved Contracts",
    approvedSubtitle: "Active credit sale contracts",
    approvedEmpty: "No active contracts",
    approvedUSDCWarn: "Your USDC deposit:",
    approvedUSDCWarn2: "Deposit USDC first to make payment.",
    approvedPay: "Make Payment",
    approvedClaimCol: "Default claim qilish",
    approvedClaimBL: "Default claim qilish",
    approvedYouBuyer: "You are buyer",
    approvedYouSeller: "You are seller",
    approvedExpired: "Expired",
    approvedTimeLeft: "left",
    approvedDays: "d",
    approvedHours: "h",
    approvedPaySuccess: "Payment completed successfully!",
    approvedClaimColSuccess: "Default claim muvaffaqiyatli bajarildi!",
    approvedClaimBLSuccess: "Default claim muvaffaqiyatli bajarildi!",
    approvedNoUSDC: "Insufficient USDC deposit",
    approvedDeadline: "Deadline passed",
    approvedClaimDefault: "Default claim qilish",
    approvedClaimDefaultSuccess: "Default claim muvaffaqiyatli bajarildi!",
    statusDefaulted: "Default / to‘lanmagan",
    payAfterDefault: "Keyin to‘lash",
    payAfterDefaultSuccess: "Default qarz to‘landi!",
    blacklistedWarning: "Siz qora ro‘yxatdasiz. Garovsiz sotib ololmaysiz.",
    unpaidDefaultLeft: "To‘lanmagan defaultlar",
    blTitle: "BL Level",
    blSubtitle: "Check buyer-seller trust level",
    blBuyer: "Buyer address",
    blSeller: "Seller address",
    blMe: "Me",
    blCheck: "Check BL",
    blChecking: "Checking...",
    blTotal: "Total BL Level",
    blTotalDesc: "Total trust accumulated by buyer",
    blBusy: "Busy BL",
    blBusyDesc: "Reserved for pending requests",
    blFree: "Free BL",
    blFreeDesc: "Available for new trades",
    blNote: "For no-collateral trading, buyer needs BL = DUR amount × 10.",
    blFillBoth: "Enter both addresses!",
    blInvalidAddr: "Invalid address format!",
    blMyAddr: "My address",
    blResultLevel: "BL level",
    blResultBusy: "Busy BL",
    blResultFree: "Free BL",
    blExplanation: "BL level increases when collateral trades are paid (DUR÷10) and in no-collateral trades by the DUR amount. If not paid, BL drops to 0.",
    blBuyerAddress: "Buyer address",
    blSellerAddress: "Seller address (optional)",
    blSearching: "Searching...",
    blSearch: "Search",
    blTotalLevel: "Total BL level",
    blTotalBL: "Total BL",
    blPendingBL: "Reserved BL",
    blFreeTotal: "Free total BL",
    blPairwise: "Pairwise BL with this seller",
    blActiveExposure: "Active uncollateralized debt (this seller)",
    blBlacklist: "Blacklist",
    blYes: "Yes",
    blNo: "No",
    blUnpaidNoCollateral: "Unpaid uncollateralized debts",
    blUnpaidDefault: "Total unpaid defaults",
    blInfo: "When approving an uncollateralized listing, the contract usually checks pairwise BL with the seller or free total BL, not total BL.",
    historyTitle: "Transaction History",
    historySubtitle: "Your recent actions",
    historyClear: "Clear",
    historyEmpty: "No transactions yet",
    historyEmptyDesc: "Your actions will appear here",
    historyExplorer: "Explorer",
    historyListing: "Listing",
    historyRole: "Role",
    historyNewBL: "New BL:",
    historyBLT: "BLT:",
    historyCreated: "Listing posted",
    historyApproved: "Listing approved",
    historyPaid: "Payment completed",
    historyCollateral: "Collateral claimed",
    historyBLClaimed: "Default claim qilindi",
    historyBuyer: "buyer",
    historySeller: "seller",
    historySecondsAgo: "seconds ago",
    historyMinutesAgo: "minutes ago",
    historyHoursAgo: "hours ago",
    historyDaysAgo: "days ago",
    statusPendingSellerC: "Seller waiting (collateral)",
    statusPendingBuyerC: "Buyer waiting (collateral)",
    statusPendingSellerN: "Seller waiting (no collateral)",
    statusPendingBuyerN: "Buyer waiting (no collateral)",
    statusApproved: "Approved",
    statusRemoved: "Removed",
    statusPaid: "Paid",
    statusClaimCol: "Default",
    statusClaimBL: "Default",
    // Tokenomics
    tokenSubtitle: "Full information about DUR and BLT tokens — supply, lock and market value",
    tokenTotalSupply: "Total Supply",
    tokenCirculating: "Circulating Supply",
    tokenLocked: "Locked",
    tokenPrice: "Price",
    tokenDistribution: "Distribution",
    tokenAbout: "About Project",
    tokenAddresses: "Token Addresses",
    connectPrompt: "Connect wallet to make transactions",
    aboutDoc: "Document",
    noData: "No data",
    errorOccurred: "An error occurred",
    days: "d",
    // About page
    aboutPageTitle: "About the Platform",
    aboutPageSubtitle: "NasiyaSale — a decentralized credit trading platform",
    aboutWhatIs: "What is NasiyaSale?",
    aboutWhatIsDesc1: "NasiyaSale is a decentralized platform developed for buying and selling DUR tokens on credit. All trades are executed through a smart contract with no intermediaries or administrators required.",
    aboutWhatIsDesc2: "The seller places DUR tokens, the buyer takes them on credit and pays in USDC within the specified period. In collateral trades, the buyer deposits collateral — if they don't pay, the collateral goes to the seller.",
    aboutSmartTitle: "Smart contract — no human control",
    aboutSmartDesc1: "All actions (posting listings, approval, payment, collateral return) are fully executed by the smart contract. There is no admin, owner, or controller — the contract is autonomous.",
    aboutSmartDesc2: "No one can stop the contract, steal tokens, or change the rules. The code was deployed once and cannot be modified.",
    aboutHowTitle: "How does it work?",
    aboutStep1Title: "1. Post a Listing",
    aboutStep1Desc: "The seller or buyer posts a listing. The seller transfers DUR tokens from their wallet to the contract.",
    aboutStep2Title: "2. Approval",
    aboutStep2Desc: "The other party reviews and approves the listing. In collateral trades, the collateral token is taken from the wallet. DUR is sent to the buyer.",
    aboutStep3Title: "3. Payment",
    aboutStep3Desc: "The buyer pays in USDC within the deadline. Payment goes directly from the wallet to the seller. Collateral is returned.",
    aboutStep4Title: "4. If Not Paid",
    aboutStep4Desc: "After the deadline, the seller claims the collateral (collateral trade) or the buyer's BL level drops to 0 (no collateral).",
    aboutBLTitle: "BL (Business Level) System",
    aboutBLDesc: "BL is the trust level between buyer and seller. Each successful payment increases BL:",
    aboutBLRow1Label: "Collateral trade",
    aboutBLRow1Value: "BL += DUR amount ÷ 10",
    aboutBLRow2Label: "No collateral trade",
    aboutBLRow2Value: "BL += DUR amount",
    aboutBLRow3Label: "If not paid",
    aboutBLRow3Value: "Faqat o‘sha sotuvchi bilan BL = 0 bo‘ladi",
    aboutBLRow4Label: "For no-collateral listing",
    aboutBLRow4Value: "BL ≥ DUR × 10 required",
    aboutTokensTitle: "Supported Tokens",
    aboutTokenDUR: "Main token for credit trading",
    aboutTokenUSDC: "Stable token for payment and collateral",
    aboutTokenUSDT: "Can be used as collateral",
    aboutTokenBLT: "Collateral token, price from Uniswap V4",
    aboutTokenWBTC: "Wrapped Bitcoin, for collateral",
    aboutTokenWETH: "Wrapped Ethereum, for collateral",
    aboutRoleTrade: "Trade",
    aboutRolePayCol: "Payment / Collateral",
    aboutRoleCol: "Collateral",
    // Transaction History
    txTitle: "Transaction History",
    txSubtitle: "Your transaction history",
    txRefresh: "Refresh",
    txLoading: "Loading...",
    txEmpty: "No transactions yet",
    txEventCreated: "Listing posted",
    txEventApproved: "Listing approved",
    txEventCancelled: "Listing cancelled",
    txEventPaid: "Payment completed",
    txEventCollateral: "Collateral claimed",
    txEventBLClaimed: "Default claim qilindi",
    txLabelCreateListing: "Listing created",
    txLabelListingApprove: "Listing approved",
    txLabelListingCancel: "Listing cancelled",
    txLabelPayment: "Payment made",
    txLabelDefaultClaim: "Default claimed",
    txLabelPayAfterDefault: "Paid after default",

    navSettings: "Settings",
    settingsTitle: "Settings",
    settingsSubtitle: "Listing creation settings. Set once \u2014 applied automatically to every listing.",
    settingsDurationLabel: "Listing duration",
    settingsDurationDesc: "If a new listing is not approved within this period, it is automatically cancelled. Default: 90 days.",
    settingsDurationRange: "Range",
    settingsDays: "days",
    settingsSaved: "Saved",
    settingsDeviationLabel: "Price deviation limit",
    settingsDeviationDesc: "If the market price at approval deviates from the locked price by more than this percent, the transaction is automatically reverted (flash loan protection). Default: 0.01%.",    clInfoDURFromWallet: "DUR token (from wallet)",

    settingsApproveMultLabel: "Approve amount",
    settingsApproveMultDesc: "How much token to approve per listing. Higher value = approve is not requested again on future listings (saves gas), but requires more trust in the contract.",
    settingsApproveMult1: "1x (exact)",
    settingsApproveMultMax: "Unlimited",
    settingsApproveMultMaxWarn: "Unlimited approve \u2014 the contract can withdraw an unlimited amount of this token at any time. Only for trusted contracts.",
    settingsRevokeLabel: "Revoke all approvals",
    settingsRevokeDesc: "Resets all token allowances granted to the contract to 0. A transaction is sent only for tokens that have an allowance (separate confirmation for each). Use after finishing trading for safety.",
    settingsRevokeBtn: "Revoke all",
    settingsRevoking: "Revoking...",
    settingsRevokeChecking: "Checking approvals...",
    settingsRevokeProgress: "revoking...",
    settingsRevokeNone: "No approvals to revoke",
    settingsRevokeDone: "approvals revoked",
    settingsRevokeRejected: "Revoke rejected",
    settingsRevokeConfirmQ: "Are you sure? A separate confirmation will be requested for each token.",
    settingsRevokeConfirmYes: "Yes, revoke",
    settingsRevokeConfirmNo: "No",    clInfoCollateralOnApproval: "Collateral from selected tokens (taken on approval)",
    clInfoBuyerPaidCollateral: "You receive USDC, buyer's BL increases (DUR÷10)",
    clInfoBuyerNotPaidCollateral: "You get the collateral, buyer's BL = 0",
    clInfoNoNeedBL: "No",
    clInfoCollateralTakenOnPost: "✅ Collateral token is taken FROM WALLET when posting",
    clInfoSellerDUROnApproval: "DUR token (taken on approval)",
    clInfoYouPaidCollateral: "Collateral returns, your BL increases (DUR÷10)",
    clInfoYouNotPaidCollateral: "Collateral goes to seller, your BL = 0",
    clInfoOnlyBLNeeded: "Nothing — only BL required",
    clInfoBuyerPaidNoColl: "You receive USDC, buyer's BL increases (by DUR amount)",
    clInfoBuyerNotPaidNoColl: "Nothing — buyer's BL = 0",
    clInfoRiskHigh: "⚠️ High",
    clInfoBLFromPrevious: "From previous collateral trades",
    clInfoYouPaidNoColl: "Your BL increases (by DUR amount)",
    clInfoYouNotPaidNoColl: "Your BL becomes 0",
    clDURFromWalletAlert: "DUR will be taken from your wallet. Wallet balance:",
    clCollateralBuyWarningTitle: "Attention!",
    clCollateralBuyWarning: "When posting, the collateral token is immediately transferred from your wallet to the contract. If you cancel before seller approval, the collateral is returned.",
    clSelectCollateralTokens: "Which tokens can the buyer use as collateral?",
    clCurrentPricePreview: "At current price, buyer must deposit collateral:",
    clPriceLockWarning: "⚠ Prices are locked when posted — this amount is used at approval even if market price changes",
    clSelectCollateralToken: "Select collateral token",
    clTokenTakenOnPost: "(taken from wallet when posting)",
    clRequiredCollateral: "Required collateral:",
    clWalletBalance: "Wallet:",
    clInsufficientToken: "— insufficient!",
    clEnterDUR: "Enter DUR amount!",
    clEnterPrice: "Enter price!",
    clEnterPeriod: "Enter payment period!",
    clSelectOneToken: "Select at least one collateral token!",
    clDURInsufficient: "Insufficient DUR! Wallet:",
    clTokenInsufficient: "insufficient! Wallet:",
    clTokenNeeded: "needed:",
    clWalletInsufficient: "Insufficient tokens in wallet!",
    clZeroCollateral: "Collateral amount is zero — check the price!",
    clPaymentProcessing: "Processing payment...",
    approvedUSDCAlert: "Payment is made in USDC from your wallet. Wallet:",
    approvedRefresh: "Refresh",
    approvedCollateralLabel: "Collateral:",
    approvedUSDCInsufficient: "Insufficient USDC!",
    dashActiveUsers: "Active Participants",
    dashActiveUsersDesc: "Unique addresses",
    searchPlaceholder: "ID, address or amount...",
    filterAll: "All",
  },
};

export const LANGUAGES = [
  { code: 'uz', label: "O'zbek", flag: '🇺🇿' },
  { code: 'kr', label: 'Ўзбек', flag: '🇺🇿' },
  { code: 'ru', label: 'Русский', flag: '🇷🇺' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
];

export const DEFAULT_LANG = 'uz';
